import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil, switchMap, finalize, map } from 'rxjs/operators';
import { Subject, Observable, EMPTY, from } from 'rxjs';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { AssigTripsService } from '../../assigned-trips/assigntrips-service/assigntrips-service';
import * as moment from 'moment';
import * as _ from 'underscore';
import { ServiceAreasService } from '../../service-areas/service-areas-service/service-areas.service';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import { sweetAlert } from 'src/app/utils/swal';
import { getDistanceFromLatLon } from 'src/app/utils/utils.common';
import { ViolationService } from '../../violations-sets/violation-service/violation.service';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { PlannerHelpingService } from 'src/app/service/planning-services/planner-helping-service';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';
import { ToastrService } from 'ngx-toastr';
import { trigger, transition, style, animate, group } from '@angular/animations';
import { BreakModalService } from 'src/app/modals/break-modal/break-modal-service/break-modal.service';

@Component({
  selector: 'app-trip-sheet',
  templateUrl: './trip-sheet.component.html',
  styleUrls: ['./trip-sheet.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('unassignedCard', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.95) translateY(-10px)', height: 0, marginTop: 0, overflow: 'hidden' }),
        group([
          animate('650ms cubic-bezier(0.16, 1, 0.3, 1)', style({ height: '*', marginTop: '*' })),
          animate('560ms 90ms cubic-bezier(0.34, 1.56, 0.64, 1)', style({ opacity: 1, transform: 'scale(1) translateY(0)' }))
        ])
      ]),
      transition(':leave', [
        style({ overflow: 'hidden' }),
        group([
          animate('420ms 120ms ease-in', style({ height: 0, marginTop: 0 })),
          animate('380ms ease-in', style({ opacity: 0, transform: 'scale(0.95) translateY(-10px)' }))
        ])
      ])
    ])
  ]
})
export class TripSheetComponent implements OnInit, OnDestroy {
  tripSheetRowPx = 7.619;
  @ViewChild("timer1", { static: false }) timer: any;
  tripSheetCushionBaseClass = 'absolute left-0 right-0 z-[1] pointer-events-none box-border bg-gray-200 rounded-t-lg';
  tripSheetPerformanceBaseClass = 'absolute left-0 right-0 z-[2] pointer-events-none box-border bg-amber-200/50 border-t border-amber-400/50 rounded-t-lg backdrop-blur-[1px]';
  duration = 30 * 1000; // 30 seconds
  driverList: any[] = [];
  user: any;
  isShowAllTrips = false;
  isAllowToHover = false;
  singleDate;
  todayDate;
  skip = 0;
  driverTrips: any = {};
  allTrips: any[] = [];
  drivers: any[] = [];
  selectedDropdownIndex: any;
  toggleActionButtons: boolean = false;
  timeZone: string = '';
  search: string = '';
  stationManagerList: any[] = [];
  selectedServiceArea = '';
  filteredServiceAreas: any[] = [];
  serviceAreaList: any[] = [];
  preServiceAreas: any = {};
  selectedDriver: any;
  selectedStationManager: any;
  filteredDrivers: any[] = [];
  tripDetailModalObj: any;
  completedTripModalObj: any;
  breakModalObj: any = null;
  isUnAssignEnabled = false;
  isCancelUnabled = false;
  showSlideFilter = false;
  timeCalibration = 'none';
  showBreak = true;
  preDriverList: any = {};
  preShiftOverrides: any = {};
  selectedShifts: any = {};
  driverShift = true;
  activeDriversOnly = false;
  corporateList: any[] = [];
  preCooperates: any = {};
  levelOfServiceList: any[] = [];
  preLevelOfServices: any = {};
  spaceTypeList: any[] = [];
  preSpaceTypes: any = {};
  filteredCorporates: any[] = [];
  filteredLevelOfService: any[] = [];
  filteredSpaceTypes: any[] = [];
  driversPerPage = 15;
  isTimerEnabled = true;
  /** Visible driver column width: adjust by ±5, between min and max. */
  driversPerPageMin = 5;
  driversPerPageMax = Infinity;
  driversPerPageStep = 5;
  selectedSpaceType = '';
  selectedCooperate = '';
  selectedLOS = '';
  hoveredTrip = null;
  timeFormat: string = 'HHmm';
  /** Left time rail: 30-min steps (0000, 0030, …, 2330); matches repeat(48, 80px) timeline rows */
  timeAxisHalfHourLabels: { label: string; onHour: boolean }[] = (() => {
    const ticks: { label: string; onHour: boolean }[] = [];
    for (let h = 0; h < 24; h++) {
      const hh = h < 10 ? '0' + h : String(h);
      ticks.push({ label: hh + '00', onHour: true });
      ticks.push({ label: hh + '30', onHour: false });
    }
    return ticks;
  })();
  status = "active";
  sortBy: 'trip' | 'vehicle' = 'trip';
  tripStatuses = [
    { label: 'Assigned', status: 'hanging', isChecked: true },
    { label: 'En Route', status: 'onway', isChecked: true },
    { label: 'Arrived', status: 'arrived', isChecked: true },
    { label: 'In Progress', status: 'started', isChecked: true },
    { label: 'Completed', status: 'finished', isChecked: false },
    { label: 'Cancelled', status: 'cancelled', isChecked: false },
  ];
  isShowStatusDropdown = false;

  selectedDate: any;
  scheduleTime: any;
  driverId: any;
  isRdispatcher = false;
  driversTimelines: any = {};
  isShowColorInformation = false;
  isShowUnassignedTimeInfo = false;
  showUnassignedSidebar = true;
  undoStack: Array<{
    type: 'assign' | 'reschedule' | 'unassigned' | 'multiAssign';
    trip: any;
    prevDriverId: any;
    prevStatus: string;
    prevJobStatus: string;
    driverName: string;
    prevScheduleTime?: string;
    prevAppointmentTime?: string | null;
    /** type === 'multiAssign' only: every trip id assigned in that batch, so one undo reverts them all. */
    tripIds?: string[];
  }> = [];
  version = '1';
  assignModalObj: any;
  componentType: any;
  secondaryCompType: any;
  /** ETA chain computed via setupTripsByPickup logic: driverId → tripId → { pickupEta, dropoffEta, travelMins } */
  driverEtaMap: { [driverId: string]: { [tripId: string]: { pickupEta: string; dropoffEta: string; travelMins: number } } } = {};
  /** Violation settings loaded from API — mirrors driver-load-v3 violations */
  violations: any = {};
  driverTripModalObj: any;
  timeRescheduleModalObj: {
    trip: any;
    oldScheduleTime: string;
    oldAppointmentTime: string | null;
    newScheduleTime: string;
    newAppointmentTime: string | null;
    oldTimeDisplay: string;
    newTimeDisplay: string;
    newMeridiem?: string;
  } | null = null;
  isGoogleMiles = false;

  /** Cached values to prevent re-computation on every change detection cycle */
  cachedDisplayDrivers: string[] = [];
  cachedDriverColumnCount: number = 0;
  cachedShiftBreakdowns: { [driverId: string]: any } = {};
  /** Cached tooltip titles — precomputed once, not on every CD cycle */
  cachedTripTitles: { [tripId: string]: any[] } = {};
  /** Cached grid-item styles to avoid returning new objects every CD cycle */
  cachedTripGridStyles: { [tripId: string]: { [key: string]: string } } = {};

  // Hover block tracking
  hoveredRowStart: number = -1;
  expandedColumnIndex: number = -1;
  expansionTimer: any = null;
  lastTimerColIndex: number = -1;
  hoveredColumnIndex: number = -1;
  isHoverExpansionEnabled: boolean = false;
  hoveredTripId: string | null = null;
  editTripModalObj: any;
  isStandingOrderClone: boolean = false;
  isDetailsModalOpen: boolean = false;
  editTaxiRideModalObj: any;

  /** Inline schedule/appointment time editing for unassigned trip cards */
  editingTimeField: { tripId: string; field: 'scheduleTime' | 'appointmentTime'; meridiem?: 'AM' | 'PM' } | null = null;
  private inlineTimeDebounceTimers: { [key: string]: any } = {};
  /** Fields that just saved successfully — each briefly flashes green in place instead of a toast.
   * Keyed like inlineTimeDebounceTimers ("tripId_field") since a schedule-time save can flash both
   * fields at once (updating the dropoff time along with it). */
  private justSavedFields = new Set<string>();
  private justSavedFieldTimers: { [key: string]: any } = {};
  /** Trip whose update-trip API call is currently in flight — drives the "Saving…" indicator. */
  savingTripId: string | null = null;

  /** Trip ids currently checked in the unassigned sidebar for a multi-trip drag */
  selectedUnassignedTripIds: Set<string> = new Set<string>();
  /** Trip ids actually being dragged right now (either the single dragged trip, or the whole selection) */
  activeDragTripIds: string[] = [];

  constructor(
    private cdr: ChangeDetectorRef,
    private driverService: DriversService,
    private sharedDataService: SharedDataService,
    private violationService: ViolationService,
    private assignTripService: AssigTripsService,
    private serviceArea: ServiceAreasService,
    private corporateService: CorporateService,
    private levelOfServiceService: LevelOfServiceService,
    private plannerHelpingService: PlannerHelpingService,
    private socketService: SocketService,
    private toastr: ToastrService,
    private breakService: BreakModalService,
  ) {
  }

  isFetchingComplete: boolean = false;

  refreshSubject = new Subject<void>();
  currentTimePosition: number = 0;
  timeInterval: any = null;


  ngOnInit(): void {
    const savedLimit = localStorage.getItem('tripSheet_driversPerPage');
    if (savedLimit) {
      const n = Number(savedLimit);
      if (!isNaN(n)) {
        this.driversPerPage = Math.max(this.driversPerPageMin || 5, n);
      }
    }

    const savedHoverExpansion = localStorage.getItem('tripSheet_hoverExpansionEnabled');
    if (savedHoverExpansion !== null) {
      this.isHoverExpansionEnabled = savedHoverExpansion === 'true';
    }

    this.socketService
      .addListener(Events.GET_COMPANY_DRIVER_STATUS)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data.success && data.drivers) {
          data.drivers.forEach(d => {
            if (!this.preDriverList || !this.preDriverList[d._id]) return;
            const driver = this.preDriverList[d._id];
            if (!driver) return;
            driver.latitude = d.latitude;
            driver.longitude = d.longitude;
          });
        }
      });

    setInterval(() => {
      this.socketService.emit(Events.GET_COMPANY_DRIVER_STATUS);
    }, 5000);

    this.getUser();
    this.setupRefreshListener();
  }

  setupRefreshListener() {
    this.refreshSubject.pipe(
      takeUntil(componentDestroyed(this)),
      switchMap(() => {
        this.isFetchingComplete = false;

        return this.fetchTripsInBatches([], 0).pipe(
          finalize(() => {
            console.log('Fetching trips completed or errored');
            this.isFetchingComplete = true;
          })
        );
      })
    ).subscribe();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.user = data
          this.timeZone = data.timeZone;
          if (data.timeFormat) {
            this.timeFormat = data.timeFormat;
            this.timeAxisHalfHourLabels = this.buildTimeAxisLabels();
          }
          this.todayDate = [
            moment.tz(this.timeZone).startOf("day").toISOString(),
            moment.tz(this.timeZone).endOf("day").toISOString(),
          ];
          this.singleDate = this.todayDate[0];
          this.setupTimeIndicator();

          if (this.user.sRoles && this.user.sRoles === "rdispatcher") {
            this.selectedStationManager = [this.user.sId];
            this.isRdispatcher = true;
          }

          this.getDriverList();
          this.cdr.markForCheck();
        }
      });
  }



  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.serviceAreaList = data;
            this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
            this.cdr.markForCheck();
          }
        });
  }

  getDriverList() {
    this.driverService.getDrivers(this.user._id, "active")
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preDriverList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
            if (this.isRdispatcher) {
              data = data.filter(item => item.stationManager === this.user.sId);
            }

            this.driverList = data;
            this.getServiceAreas();
            this.getCorporate();
            this.getLevelOfService();
            this.getSpaceTypes();
            this.getViolationData();
            this.getRefreshTrips();
            this.getDriversTimelines();
            this.getShiftOverrides();
            this.cdr.markForCheck();
          }
        },
      );
  }

  getCorporate() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.corporateList = data;
          this.preCooperates = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          this.cdr.markForCheck();
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getLevelOfService() {
    this.levelOfServiceService
      .getLevelOfServices({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.levelOfServiceList = data;
          this.preLevelOfServices = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          this.cdr.markForCheck();
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getSpaceTypes() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.spaceTypeList = data;
          this.preSpaceTypes = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          this.cdr.markForCheck();
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  fetchTripsInBatches(accumulatedTrips: any[] = [], currentSkip: number = 0): Observable<any> {
    const jobStatuses = ['pending', 'marketplaced'];
    this.tripStatuses.forEach(t => {
      if (t.isChecked) {
        if (t.status === 'hanging') {
          jobStatuses.push('offered', 'accepted');
        } else if (t.status === 'completed') {
          jobStatuses.push('finished', 'completed');
        } else {
          jobStatuses.push(t.status);
        }
      }
    });

    const body = {
      isShowAllTrips: this.isShowAllTrips,
      status: 'manifest',
      date: this.todayDate,
      showBreak: this.showBreak,
      skip: currentSkip,
      jobStatuses
    };

    return this.assignTripService.getAssignList(body).pipe(
      switchMap(data => {
        if (data && data.length) {
          return from((async () => {
            if (this.timeCalibration && this.timeCalibration !== "none") {
              if (this.timeCalibration === "pickup-wise") {
                await this.plannerHelpingService.applyPickupWiseCalibration(this.isGoogleMiles, data, this.user);
              } else if (this.timeCalibration === "dropoff-wise") {
                await this.plannerHelpingService.applyDropoffWiseCalibration(this.isGoogleMiles, data, this.user);
              } else {
                await this.plannerHelpingService.applyMemberWiseHybridCalibration(this.isGoogleMiles, data, this.user);
              }
            }
            return data;
          })()).pipe(
            switchMap(calibratedData => {
              const newAccumulated = _.uniq([...accumulatedTrips, ...calibratedData], '_id');
              return this.fetchTripsInBatches(newAccumulated, currentSkip + calibratedData.length);
            })
          );
        } else {
          // All batches completed
          this.allTrips = accumulatedTrips;
          this.skip = currentSkip;

          if (this.timer) {
            if (this.isTimerEnabled)
              this.timer.start();
          }
          this.isAllowToHover = true;
          return from(this.prepareDataFilters()).pipe(
            map(() => EMPTY)
          );
        }
      })
    );
  }

  getRefreshTrips() {
    this.getDriversTimelines();
    this.getShiftOverrides();
    this.refreshSubject.next();
  }

  updateCurrentTimePosition() {
    const now = moment().tz(this.timeZone);
    const isToday = now.isSame(moment(this.todayDate[0]).tz(this.timeZone), 'day');
    if (isToday) {
      this.currentTimePosition = this.getStartPoint(now.toISOString(), true);
    } else {
      this.currentTimePosition = 0;
    }
  }

  isAmPmFormat(): boolean {
    return /a/i.test(this.timeFormat);
  }

  /** Rebuilds the left time rail labels in the company's timeFormat. */
  private buildTimeAxisLabels() {
    return this.timeAxisHalfHourLabels.map((tick, i) => ({
      ...tick, label: moment.utc().startOf('day').add(i * 30, 'minutes').format(this.timeFormat)
    }));
  }

  setupTimeIndicator() {
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
    this.updateCurrentTimePosition();
    this.scrollToCurrentTime();
    this.timeInterval = setInterval(() => {
      this.updateCurrentTimePosition();
      console.log(`Updated currentTimePosition: ${this.currentTimePosition}`);
      if (this.isFetchingComplete) {
        this.filterTrips();
      }
    }, 60000);
  }

  onGridScroll(event: any) {
    const scrollLeft = event.target.scrollLeft;

    // Clear expansion when scrolling to prevent "jumping" UI
    if (this.expandedColumnIndex !== -1) {
      this.expandedColumnIndex = -1;
      this.cdr.markForCheck();
    }

    const headerScroll = document.getElementById('header-scroll');
    if (headerScroll) {
      headerScroll.style.transform = `translateX(-${scrollLeft}px)`;
    }
  }

  scrollToCurrentTime() {
    setTimeout(() => {
      const container = document.getElementById('scrollContainer');
      if (container && this.currentTimePosition > 0) {
        // Grid: 64px header (row 1), then 7.619px per 5-min slot (row 2 = 00:00)
        const pixelTop = 64 + (this.currentTimePosition - 2) * this.tripSheetRowPx;
        container.scrollTop = Math.max(0, pixelTop - 200);
      }
    }, 500);
  }

  draggingUnassignedTrip: any = null;

  scrollToTripTime(trip: any) {
    this.activeDragTripIds = (this.selectedUnassignedTripIds.has(trip._id) && this.selectedUnassignedTripIds.size > 1)
      ? Array.from(this.selectedUnassignedTripIds)
      : [trip._id];

    const container = document.getElementById('scrollContainer');
    if (!container || !trip || !trip.scheduleTime) return;
    const slotRow = this.getStartPoint(trip.scheduleTime, true);
    const pixelTop = 64 + (slotRow - 2) * this.tripSheetRowPx;
    container.scrollTo({ top: Math.max(0, pixelTop - 200), behavior: 'smooth' });
    this.draggingUnassignedTrip = trip;
  }

  onUnassignedDragEnded() {
    this.draggingUnassignedTrip = null;
    // CDK fires (cdkDragEnded) synchronously before (cdkDropListDropped) — see
    // _cleanupDragArtifacts in @angular/cdk drag-drop.js, which calls
    // `ended.next()` immediately followed by `dropped.next()` in the same callback.
    // Clearing activeDragTripIds here directly would wipe it before onTripDropped
    // gets a chance to read it, so defer the reset to the next macrotask.
    setTimeout(() => {
      this.activeDragTripIds = [];
      this.cdr.markForCheck();
    });
  }

  getDragHighlightWrapperStyle() {
    return {
      'grid-template-rows': '64px repeat(288, 7.619px) auto',
      'grid-column': '1 / -1'
    };
  }

  getDragHighlightBlockStyle() {
    if (!this.draggingUnassignedTrip) return {};
    const rowStart = this.getStartPoint(this.draggingUnassignedTrip.scheduleTime, true);
    const rowSpan = this.getEndPoint(this.draggingUnassignedTrip.scheduleTime, this.draggingUnassignedTrip.appointmentTime);
    return {
      'grid-row': rowStart + ' / span ' + rowSpan,
      'grid-column': '1 / -1'
    };
  }

  async prepareDataFilters(): Promise<void> {
    this.stationManagerList = [];
    let serviceAreas = [];
    let cooperates = [];
    let levelOfServices = [];
    let spaceTypes = [];

    this.drivers = this.driverList.map(driver => ({
      _id: driver._id,
      displayName: driver.displayName,
      stationManager: driver.stationManager
    }));

    this.allTrips.forEach(trip => {
      if (trip.driver && trip.driver.stationManager) {

        if (this.isRdispatcher) {
          if (trip.driver.stationManager === this.user.sId) {
            this.stationManagerList.push(trip.driver.stationManager);
          }

        } else {
          this.stationManagerList.push(trip.driver.stationManager);
        }

      }

      if (trip.serviceArea) {
        serviceAreas.push(trip.serviceArea);
      }
      if (trip.cooperate) {
        cooperates.push(trip.cooperate);
      }
      if (trip.los) {
        levelOfServices.push(trip.los);
      }

      if (trip.spaceType) {
        spaceTypes.push(trip.spaceType);
      }
    });

    this.drivers = _.uniq(this.drivers, '_id').sort();
    this.stationManagerList = _.uniq(this.stationManagerList).sort();
    cooperates = _.uniq(cooperates).sort();
    levelOfServices = _.uniq(levelOfServices).sort();
    spaceTypes = _.uniq(spaceTypes).sort();

    if (serviceAreas && serviceAreas.length) {
      this.filteredServiceAreas = this.serviceAreaList.filter(s => serviceAreas.includes(s._id));
    }
    if (cooperates && cooperates.length) {
      this.filteredCorporates = this.corporateList.filter(c => cooperates.includes(c._id));
    }

    if (levelOfServices && levelOfServices.length) {
      this.filteredLevelOfService = this.levelOfServiceList.filter(l => levelOfServices.includes(l._id));
    }

    if (spaceTypes && spaceTypes.length) {
      this.filteredSpaceTypes = this.spaceTypeList.filter(s => spaceTypes.includes(s._id));
    }
    this.filteredDrivers = this.drivers;

    await this.filterTrips();
  }


  async filterTrips(): Promise<void> {
    let filterdataList = this.allTrips.map(t => ({ ...t }));

    filterdataList = filterdataList.filter(trip => {

      let isNoDriver = !trip.driver;

      let isDriverExist = true;
      let isStaffExist = true;
      let isServiceAreaExist = true;
      let isCorporateExist = true;
      let islosExist = true;
      let isSpaceTypeExist = true;
      let isCancelUnabled = true;
      let isSearchMatch = true;

      // ================= DRIVER FILTER =================
      if (this.selectedDriver && this.selectedDriver.length) {
        if (isNoDriver) {
          // allow no_driver unless search is applied
          isDriverExist = !this.search;
        } else {
          isDriverExist =
            trip.driver &&
            trip.driver._id &&
            this.selectedDriver.indexOf(trip.driver._id) !== -1;
        }
      }

      // ================= STATION MANAGER FILTER =================
      if (this.selectedStationManager && this.selectedStationManager.length) {
        if (isNoDriver) {
          isStaffExist = !this.search;
        } else {
          isStaffExist =
            trip.driver &&
            trip.driver.stationManager &&
            this.selectedStationManager.indexOf(trip.driver.stationManager) !== -1;
        }
      }

      // ================= OTHER FILTERS =================
      if (this.selectedServiceArea && this.selectedServiceArea.length) {
        isServiceAreaExist =
          trip.serviceArea &&
          this.selectedServiceArea.indexOf(trip.serviceArea) !== -1;
      }

      if (this.selectedCooperate && this.selectedCooperate.length) {
        isCorporateExist =
          trip.cooperate &&
          this.selectedCooperate.indexOf(trip.cooperate) !== -1;
      }

      if (this.selectedLOS && this.selectedLOS.length) {
        islosExist =
          trip.los &&
          this.selectedLOS.indexOf(trip.los) !== -1;
      }

      if (this.selectedSpaceType && this.selectedSpaceType.length) {
        isSpaceTypeExist =
          trip.spaceType &&
          this.selectedSpaceType.indexOf(trip.spaceType) !== -1;
      }

      // ================= CANCELLED FILTER =================
      if (this.isCancelUnabled) {
        isCancelUnabled = trip.status === 'cancelled';
      }

      // ================= SEARCH FILTER =================
      if (this.search && this.search.trim().length > 0) {

        var searchTerm = this.search.toLowerCase();

        var isDriverName = false;
        var isMemberName = false;
        var isTripId = false;
        var isMemberPhone = false;

        if (trip.driver && trip.driver.displayName) {
          isDriverName =
            trip.driver.displayName.toLowerCase().indexOf(searchTerm) !== -1;
        }

        if (trip.priorityClient && trip.priorityClient.displayName) {
          isMemberName =
            trip.priorityClient.displayName.toLowerCase().indexOf(searchTerm) !== -1;
        }

        if (trip.tripId) {
          isTripId =
            trip.tripId.toLowerCase().indexOf(searchTerm) !== -1;
        }

        if (trip.priorityClient && trip.priorityClient.cellPhone) {
          isMemberPhone =
            trip.priorityClient.cellPhone.toLowerCase().indexOf(searchTerm) !== -1;
        }

        isSearchMatch =
          isDriverName || isMemberName || isTripId || isMemberPhone;
      }

      // ================= FINAL RETURN =================
      return (
        isDriverExist &&
        isStaffExist &&
        isServiceAreaExist &&
        isCorporateExist &&
        islosExist &&
        isSpaceTypeExist &&
        isCancelUnabled &&
        (!this.search || isSearchMatch)
      );
    });

    // ================= GROUPING =================
    const groupedTrips = _.groupBy(filterdataList as any[], function (trip: any) {
      if (!trip.driver) return 'no_driver';

      if (typeof trip.driver === 'string') {
        return trip.driver;
      }

      return trip.driver._id ? trip.driver._id : 'no_driver';
    });

    // ================= DRIVER SORTING =================

    if (this.sortBy === 'vehicle') {
      // Sort by vehicle registration number (fleet.setiDecall or rigNumber) alphabetically.
      // Drivers without a vehicle go last.
      this.driverList.sort((a: any, b: any) => {
        const getVehicleReg = (driver: any): string | null => {
          if (driver && driver.fleet && driver.fleet.setiDecall) return driver.fleet.setiDecall;
          return null;
        };
        const aReg = getVehicleReg(a);
        const bReg = getVehicleReg(b);
        if (!aReg && !bReg) return 0;
        if (!aReg) return 1;
        if (!bReg) return -1;
        return aReg.localeCompare(bReg, undefined, { numeric: true, sensitivity: 'base' });
      });
    } else {
      // Sort by earliest trip's scheduleTime. Drivers with no trips go last.
      this.driverList.sort((a: any, b: any) => {
        const aTrips: any[] = groupedTrips[a._id];
        const bTrips: any[] = groupedTrips[b._id];

        const getEarliest = (trips: any[]): number => {
          if (!trips || trips.length === 0) return Number.MAX_SAFE_INTEGER;
          return trips.reduce((min: number, trip: any) => {
            const t = trip.scheduleTime ? (moment as any)(trip.scheduleTime).tz(this.timeZone).valueOf() : Number.MAX_SAFE_INTEGER;
            return t < min ? t : min;
          }, Number.MAX_SAFE_INTEGER);
        };

        return getEarliest(aTrips) - getEarliest(bTrips);
      });
    }

    let dTrips = {};

    const promises = this.driverList.map(async (driver) => {
      let trips = groupedTrips[driver._id];
      if (trips && trips.length) {
        dTrips[driver._id] = await this.checkOverlaps(trips);
      }
    });
    await Promise.all(promises);

    this.driverTrips = dTrips;

    // ================= NO DRIVER HANDLING =================
    if (groupedTrips['no_driver']) {

      let unassignedTrips = groupedTrips['no_driver'].filter(function (trip) {
        return trip.jobStatus === 'pending' || trip.status === 'unassigned';
      });

      if (unassignedTrips.length) {
        this.driverTrips['no_driver'] = unassignedTrips;
      }
    }

    // Rebuild all caches after filtering
    this.rebuildCaches();
    this.cdr.markForCheck();
  }

  onSelectTimeCalibration(timeCalibration) {
    this.timeCalibration = timeCalibration;
    this.getRefreshTrips();
  }

  onShiftToggle(val) {
    if (!val) {
      // When Driver Shift is toggled OFF, reset all drivers to General Shift (G)
      this.driverList.forEach(driver => {
        const shift = this.getDriverShift(driver);
        if (shift) {
          this.selectedShifts[driver._id] = { shift, type: 'regular' };
          // Update caches and outside shift flags for each driver
          this.cachedShiftBreakdowns[driver._id] = this.computeShiftBreakdown(driver._id);
          this.updateDriverTripOutsideFlags(driver._id);
        } else {
          // If no general shift, clear any selection
          delete this.selectedShifts[driver._id];
        }
      });
      this.rebuildCaches();
      this.cdr.markForCheck();
    }
  }

  onDriverSelectorKeydown(event: any) {
    // If Backspace is pressed and search input is empty, deselect all drivers
    if (event.key === 'Backspace' && (!event.target.value || event.target.value === '')) {
      if (this.selectedDriver && this.selectedDriver.length > 0) {
        this.selectedDriver = [];
        this.filterTrips();
        this.cdr.markForCheck();
      }
    }
  }

  /**
   * Identifies trips that were skipped or started out of their scheduled sequence.
   * A trip is 'skipped' if it's pending but scheduled before an active/finished trip.
   */
  checkSequenceViolations(trips: any[]) {
    if (!trips || trips.length === 0) return;

    let maxActiveIndex = -1;

    // 1. Find the latest trip (by schedule order) that the driver has interacted with
    for (let i = 0; i < trips.length; i++) {
      const trip = trips[i];
      const isActiveOrFinished = ['onway', 'arrived', 'started', 'finished'].includes(trip.jobStatus) ||
        trip.status === 'finished' ||
        (trip.jobStatus === 'cancelled' && trip.status === 'finished'); // Edge cases

      if (isActiveOrFinished) {
        maxActiveIndex = i;
      }
    }

    // 2. Mark violations
    for (let i = 0; i < trips.length; i++) {
      const trip = trips[i];
      const isPending = (trip.jobStatus === 'pending' || !trip.jobStatus) &&
        trip.status !== 'cancelled' &&
        trip.status !== 'finished';
      const isActive = ['onway', 'arrived', 'started'].includes(trip.jobStatus);

      // Reset flags first
      trip.isSkipped = false;
      trip.isSequenceViolation = false;

      // Rule A: If pending but scheduled BEFORE the driver's latest active/finished trip, it's 'Skipped'
      if (isPending && i < maxActiveIndex) {
        trip.isSkipped = true;
      }

      // Rule B: If active but there are pending trips scheduled EARLIER, this trip is an 'Out of Sequence' start
      if (isActive) {
        const hasEarlierPending = trips.slice(0, i).some(t => {
          return (t.jobStatus === 'pending' || !t.jobStatus) &&
            t.status !== 'cancelled' &&
            t.status !== 'finished';
        });

        if (hasEarlierPending) {
          trip.isSequenceViolation = true;
        }
      }
    }
  }

  /**
   * Processes a list of trips to detect overlaps and determine layout positioning.
   * It calculates how many columns are needed and groups overlapping trips.
   */
  async checkOverlaps(trips: any[]): Promise<any[]> {
    // 1. Guard clause for empty data
    if (!trips || trips.length === 0) return [];

    // 2. Sort trips: primary by start time, secondary by duration (longest first)
    const processed = [...trips].sort((a, b) => {
      const aStart = moment(a.scheduleTime).tz(this.timeZone).valueOf();
      const bStart = moment(b.scheduleTime).tz(this.timeZone).valueOf();

      if (aStart !== bStart) return aStart - bStart;

      // If they start at the same time, put the longer trip first to help the layout
      const aEnd = moment(a.appointmentTime).tz(this.timeZone).valueOf();
      const bEnd = moment(b.appointmentTime).tz(this.timeZone).valueOf();
      return bEnd - aEnd;
    });
    this.checkSequenceViolations(processed);

    // 3. Initialize buffers and kick off async calculations
    processed.forEach(trip => {
      trip._preTravelMins = 15; // Default safety buffer
    });
    await this.computeTravelTimesInBackground(processed);

    // Helper: Calculates the precise start (with buffer) and end of a trip
    const overlapRange = (t: any) => {
      const preTravelMins = this.getPreTravelMins(t);
      const sched = moment(t.scheduleTime).tz(this.timeZone);
      const start = sched.clone().subtract(preTravelMins, 'minutes').valueOf();
      const end = moment(t.appointmentTime).tz(this.timeZone).valueOf();
      return { start, end };
    };

    // 4. Assign columns (subIndex)
    // We keep track of the 'end time' of the last trip in each column
    const columns: number[] = [];
    processed.forEach(trip => {
      const { start, end } = overlapRange(trip);

      // Find the first column where this trip can fit (starts after the previous trip ends)
      let colIdx = columns.findIndex(colEnd => start >= colEnd);

      if (colIdx === -1) {
        // Doesn't fit in any existing column? Create a new one.
        columns.push(end);
        trip.subIndex = columns.length - 1;
      } else {
        // Fits here? Update this column's end time.
        columns[colIdx] = end;
        trip.subIndex = colIdx;
      }
    });

    // 5. Cluster overlaps (Grouping)
    // This ensures all trips that overlap share the same 'subTotal' (total columns in that block)
    const n = processed.length;
    const visited = new Array(n).fill(false);

    for (let s = 0; s < n; s++) {
      if (visited[s]) continue;

      const cluster: number[] = [];
      const queue = [s];
      visited[s] = true;

      // Standard Breadth-First Search (BFS) to find all interconnected overlapping trips
      while (queue.length) {
        const j = queue.shift()!;
        cluster.push(j);
        const tj = overlapRange(processed[j]);

        for (let k = 0; k < n; k++) {
          if (visited[k]) continue;
          const tk = overlapRange(processed[k]);

          // Check if Trip J and Trip K physically overlap in time
          if (tj.start < tk.end && tj.end > tk.start) {
            visited[k] = true;
            queue.push(k);
          }
        }
      }

      // 6. Set the width (subTotal) for the cluster
      // The width of all trips in a cluster is determined by the max column index found
      let maxSub = 0;
      cluster.forEach(idx => {
        maxSub = Math.max(maxSub, processed[idx].subIndex || 0);
      });

      const subTotal = maxSub + 1;
      cluster.forEach(idx => {
        processed[idx].subTotal = subTotal;
      });
    }

    // 7. Final logic for calculating delays based on the new order
    await this.computeDelayChain(processed);

    return processed;
  }

  /**
   * Compute travel times asynchronously in background, then update cushions and mark for check.
   * This avoids the fire-and-forget async forEach that was flooding the event loop.
   */
  async computeTravelTimesInBackground(trips: any[]): Promise<void> {
    const promises = trips.map(async (trip) => {
      const preData = await this.calculatePreTravelData(trip, trips);
      if (preData) {
        trip._preTravelMins = preData.duration;
        trip._preTravelMiles = preData.distance;
      }
      const actualData = await this.calculateActualTravelData(trip);
      if (actualData) {
        trip._actualTravelMins = actualData.duration;
        trip._actualTravelMiles = actualData.distance;
      }
    });
    await Promise.all(promises);
  }


  async computeDelayChain(trips: any[]): Promise<void> {
    if (!trips || trips.length === 0) return;

    const tz = this.timeZone;
    const now = moment().tz(tz);
    const firstTripDate = moment(trips[0].scheduleTime).tz(tz).format('YYYY-MM-DD');
    const isToday = firstTripDate === now.format('YYYY-MM-DD');

    // ========================================================================
    // 1. CLASSIFY TRIPS FOR CALCULATION PRIORITY
    // ========================================================================
    const finishedTrips = trips.filter(t => ['finished', 'completed', 'cancelled'].includes(t.jobStatus));
    const inProgressTrips = trips.filter(t => ['onway', 'arrived', 'started'].includes(t.jobStatus));
    const pendingTrips = trips.filter(t =>
      !['finished', 'completed', 'cancelled'].includes(t.jobStatus) &&
      !['onway', 'arrived', 'started'].includes(t.jobStatus)
    );

    // Priority Order: Finished -> Active -> Pending
    // This ensures that if a driver starts Trip 3, Trip 1 and 2 (Pending) ripple FROM Trip 3.
    const calculationOrder = [...finishedTrips, ...inProgressTrips, ...pendingTrips];

    let timelineCursor: moment.Moment | null = null;
    let hasFoundFirstUpcoming = false;
    let lastActiveTrip: any = null;

    for (const trip of calculationOrder) {
      // 0. RESET FLAGS
      trip._isPickupDelayed = false;
      trip._isDropOffDelayed = false;
      trip._delayPickupMins = 0;
      trip._dropOffDelayMins = 0;

      // 1. DATA EXTRACTION
      let actualTimestamp: any = null;
      if (trip.job && trip.job.trackInfoJob) {
        const track = trip.job.trackInfoJob;
        const event = track.jobFinished || track.jobCompleted || track.jobCancelled ||
          track.jobStarted || track.jobArrived || track.jobAccepted;
        if (event && event.time) actualTimestamp = event.time;
      }

      const isFinished = ['finished', 'completed', 'cancelled'].includes(trip.jobStatus);
      const isInProgress = ['onway', 'arrived', 'started'].includes(trip.jobStatus);

      // 2. SETUP
      let travelDuration = Number(trip._actualTravelMins || 0);
      const scheduledPickup = moment(trip.scheduleTime).tz(tz);
      const appointmentDropOff = moment(trip.appointmentTime).tz(tz);

      // 3. GPS CALCULATION
      let gpsRemainingMins: number | null = null;
      if (isToday && trip.driver && trip.driver._id && this.preDriverList && this.preDriverList[trip.driver._id]) {
        const drv = this.preDriverList[trip.driver._id];

        // Determine which shift to use: selected shift or default to general shift
        let selectedShiftInfo = this.selectedShifts[trip.driver._id];
        let shiftToCheck = null;
        let shiftType = 'regular'; // default

        if (selectedShiftInfo && selectedShiftInfo.shift && selectedShiftInfo.type) {
          // Use the selected shift
          shiftToCheck = selectedShiftInfo.shift;
          shiftType = selectedShiftInfo.type;
        } else {
          // Default to general shift
          shiftToCheck = this.getDriverShift(drv);
          shiftType = 'regular';
        }

        // Check if the selected/default shift has started
        let shiftHasStarted = false;
        const normalizedShift = this.normalizeShift(shiftToCheck, shiftType);
        if (normalizedShift && normalizedShift.checkin) {
          const shiftCheckinTime = moment(normalizedShift.checkin).tz(this.timeZone);
          shiftHasStarted = now.isSameOrAfter(shiftCheckinTime);
        }

        // Determine driver location: use current GPS if shift started, otherwise use garage address
        let driverLat = null;
        let driverLng = null;

        if (shiftHasStarted && drv.latitude != null && drv.longitude != null) {
          // Shift has started: use current GPS location
          driverLat = drv.latitude;
          driverLng = drv.longitude;
        } else if (drv.startingPointAddress && drv.startingPointAddress.latitude != null && drv.startingPointAddress.longitude != null) {
          // Shift not started: use garage address as driver location
          driverLat = drv.startingPointAddress.latitude;
          driverLng = drv.startingPointAddress.longitude;
        }

        if (driverLat && driverLng) {
          const targetLat = (trip.jobStatus === 'started') ? trip.jobDestinationLatitude : trip.jobOriginLatitude;
          const targetLng = (trip.jobStatus === 'started') ? trip.jobDestinationLongitude : trip.jobOriginLongitude;
          if (targetLat && targetLng) {
            const res = await this.calculateDistance(driverLat, driverLng, targetLat, targetLng);
            gpsRemainingMins = res.duration;
          }
        }
      }

      // 4. CASE A: COMPLETED OR ACTIVE
      if (isFinished || isInProgress) {
        // Base timestamp for historical reference
        let actualMoment = actualTimestamp ? moment(actualTimestamp).tz(tz) : (isToday ? now.clone() : scheduledPickup.clone());

        if (isFinished) {
          trip._forecastStartETA = actualMoment.format(this.timeFormat);
          trip._forecastEndETA = actualMoment.format(this.timeFormat);
          timelineCursor = actualMoment.clone();
          trip._delayPickupMins = Math.round(Math.max(0, actualMoment.diff(scheduledPickup, 'minutes')));
        } else {
          // --- LIVE STATUS LOGIC ---
          lastActiveTrip = trip;
          let finishMoment: moment.Moment | null = null;
          if (trip.jobStatus === 'arrived' || trip.jobStatus === 'started') {
            // Zero out pickup details for UI
            trip._preTravelMins = 0;
            trip._delayPickupMins = 0;
            trip._isPickupDelayed = false;

            // Start time remains historical (03:42)
            trip._forecastStartETA = actualMoment.format(this.timeFormat);

            if (trip.jobStatus === 'started') {
              // THE FIX: Use NOW + GPS (18:00 + 272 = 22:32)
              if (gpsRemainingMins !== null) {
                finishMoment = now.clone().add(gpsRemainingMins, 'minutes');
                trip._actualTravelMins = gpsRemainingMins;
              } else {
                finishMoment = actualMoment.clone().add(travelDuration, 'minutes');
              }
            } else {
              // Arrived: Currently waiting, prediction starts from Now
              finishMoment = now.clone().add(travelDuration, 'minutes');
            }
          }
          else if (trip.jobStatus === 'onway') {
            trip._preTravelMins = gpsRemainingMins !== null ? gpsRemainingMins : Number(trip._preTravelMins || 0);
            const arrivalAtP = (gpsRemainingMins !== null) ? now.clone().add(trip._preTravelMins, 'minutes') : actualMoment.clone();

            trip._forecastStartETA = arrivalAtP.format(this.timeFormat);
            finishMoment = arrivalAtP.clone().add(travelDuration, 'minutes');
            trip._delayPickupMins = Math.round(Math.max(0, arrivalAtP.diff(scheduledPickup, 'minutes')));
            trip._isPickupDelayed = (trip._delayPickupMins > 0);
          }

          // Finalize Forecast End for Active Trips
          if (finishMoment) {
            trip._forecastEndETA = finishMoment.format(this.timeFormat);
            // If multiple trips are in progress, the anchor for the NEXT trip
            // is the LATEST finish time among all active commitments.
            if (!timelineCursor || finishMoment.isAfter(timelineCursor)) {
              timelineCursor = finishMoment.clone();
            }
          }
        }

        // Late(D) Calculation (Always live based on the finalized timelineCursor)
        if (timelineCursor) {
          const dDelay = Math.round(Math.max(0, timelineCursor.diff(appointmentDropOff, 'minutes')));
          trip._dropOffDelayMins = dDelay;
          trip._isDropOffDelayed = dDelay > 0;
        }

        hasFoundFirstUpcoming = true;
        if (isFinished) continue;
      }

      // 5. CASE B: PENDING (Ripple Logic)
      if (!isFinished && !isInProgress) {
        let predictedPickup: moment.Moment;
        let currentBuffer = Number(trip._preTravelMins || 0);

        if (!hasFoundFirstUpcoming) {
          // FIRST UPCOMING (No active trip yet encountered)
          if (isToday && gpsRemainingMins !== null) {
            trip._preTravelMins = gpsRemainingMins;
            currentBuffer = gpsRemainingMins;
            const liveArrival = now.clone().add(gpsRemainingMins, 'minutes');
            predictedPickup = liveArrival.isAfter(scheduledPickup) ? liveArrival : scheduledPickup.clone();
          } else {
            predictedPickup = scheduledPickup.clone();
          }
          hasFoundFirstUpcoming = true;
        } else {
          // RIPPLE FROM PREVIOUS (could be a previous pending or the last active trip)
          if (lastActiveTrip && !timelineCursor) {
            // This case shouldn't happen with priority sort, but for safety:
            predictedPickup = scheduledPickup.clone();
          } else if (timelineCursor) {
            // If we are rippling from an active trip that was out-of-order,
            // we should recalculate the distance from that trip's destination.
            if (lastActiveTrip && pendingTrips.indexOf(trip) === 0) {
              const startLat = lastActiveTrip.jobDestinationLatitude || lastActiveTrip.jobOriginLatitude;
              const startLng = lastActiveTrip.jobDestinationLongitude || lastActiveTrip.jobOriginLongitude;
              const res = await this.calculateDistance(startLat, startLng, trip.jobOriginLatitude, trip.jobOriginLongitude);
              currentBuffer = res.duration;
              trip._preTravelMins = currentBuffer;
            }

            const arrivalFromPrev = timelineCursor.clone().add(currentBuffer, 'minutes');
            predictedPickup = arrivalFromPrev.isAfter(scheduledPickup) ? arrivalFromPrev : scheduledPickup.clone();
          } else {
            predictedPickup = scheduledPickup.clone();
          }
        }

        if (isToday && predictedPickup.isBefore(now)) predictedPickup = now.clone();

        const predictedDropOff = predictedPickup.clone().add(travelDuration, 'minutes');
        trip._forecastStartETA = predictedPickup.format(this.timeFormat);
        trip._forecastEndETA = predictedDropOff.format(this.timeFormat);
        trip._delayPickupMins = Math.round(Math.max(0, predictedPickup.diff(scheduledPickup, 'minutes')));
        trip._isPickupDelayed = trip._delayPickupMins > 0;
        trip._dropOffDelayMins = Math.round(Math.max(0, predictedDropOff.diff(appointmentDropOff, 'minutes')));
        trip._isDropOffDelayed = trip._dropOffDelayMins > 0;

        timelineCursor = predictedDropOff.clone();
      }
    }
  }

  async calculatePreTravelData(currentTrip: any, uiTrips: any[]): Promise<any> {
    if (!uiTrips || !uiTrips.length || !this.timeZone) {
      return { duration: 15, distance: 0 };
    }
    const idx = uiTrips.findIndex(
      t =>
        (currentTrip.tripId && t.tripId === currentTrip.tripId) ||
        (currentTrip._id && t._id === currentTrip._id)
    );

    const prev = uiTrips[idx - 1];
    const lat1 = idx <= 0 ? this.preDriverList[currentTrip.driver._id].startingPointAddress.latitude : prev.jobDestinationLatitude;
    const lon1 = idx <= 0 ? this.preDriverList[currentTrip.driver._id].startingPointAddress.longitude : prev.jobDestinationLongitude;

    const lat2 = currentTrip.jobOriginLatitude;
    const lon2 = currentTrip.jobOriginLongitude;

    return await this.calculateDistance(lat1, lon1, lat2, lon2);
  }

  async calculateActualTravelData(currentTrip: any): Promise<any> {
    const lat1 = currentTrip.jobOriginLatitude;
    const lon1 = currentTrip.jobOriginLongitude;
    const lat2 = currentTrip.jobDestinationLatitude;
    const lon2 = currentTrip.jobDestinationLongitude;

    return await this.calculateDistance(lat1, lon1, lat2, lon2);
  }

  getDelayColorClass(mins: number): string {
    const m = Number(mins || 0);
    if (m <= 0) return '';
    if (m <= 15) return 'bg-red-100 text-red-700 border border-red-200'; // Minor
    if (m <= 30) return 'bg-red-300 text-red-900 border border-red-400'; // Moderate
    if (m <= 60) return 'bg-red-500 text-white shadow-sm'; // Significant
    return 'bg-red-700 text-white shadow-md animate-pulse ring-1 ring-red-900'; // Critical
  }

  getPreTravelMins(trip: any): number {
    if (trip && trip._preTravelMins != null && !isNaN(Number(trip._preTravelMins))) {
      return Number(trip._preTravelMins);
    }
    return 15;
  }

  getTripCushionRows(trip: any): number {
    return Math.ceil(this.getPreTravelMins(trip) / 5);
  }

  isDriverLate(driverId: string): boolean {
    const trips = this.driverTrips[driverId] || [];
    return trips.some(t =>
      !['finished', 'completed', 'cancelled'].includes(t.jobStatus) &&
      (Number(t._delayPickupMins || 0) > 0 || Number(t._dropOffDelayMins || 0) > 0)
    );
  }

  isDriverOverloaded(driverId: string): boolean {
    const trips = (this.driverTrips[driverId] || []).filter(t => !t.isBreakTrip);
    return trips.length > 12; // Threshold for overloading
  }

  hasNoTrips(driverId: string): boolean {
    if (driverId.startsWith('empty_')) return false;
    const trips = (this.driverTrips[driverId] || []).filter(t => !t.isBreakTrip);
    return trips.length === 0;
  }

  getTripCushionStripStyle(trip: any): { [key: string]: string } {
    if (trip.isBreakTrip) {
      return {};
    }
    const rows = this.getTripCushionRows(trip);
    const px = this.tripSheetRowPx;
    return {
      top: `calc(-${rows} * ${px}px)`,
      height: `calc(${rows} * ${px}px + 0.25rem)`,
    };
  }

  /** Calculate rows for the early performance indicator (time between actual action and schedule) */
  getTripPerformanceRows(trip: any): number {
    if (trip.isBreakTrip) return 0;
    const tz = this.timeZone;
    if (!tz) return 0;

    const scheduledStart = moment.tz(trip.scheduleTime, tz);
    const trackInfo = trip.job && trip.job.trackInfoJob;
    if (!trackInfo) return 0;

    // Use earliest of Arrived or Started or Accepted
    const actionTime = (trackInfo.jobArrived && trackInfo.jobArrived.time) ||
      (trackInfo.jobStarted && trackInfo.jobStarted.time) ||
      (trackInfo.jobAccepted && trackInfo.jobAccepted.time);

    if (!actionTime) return 0;

    const actualMoment = moment.tz(actionTime, tz);
    if (actualMoment.isBefore(scheduledStart)) {
      const diffMins = scheduledStart.diff(actualMoment, 'minutes');
      return Math.ceil(diffMins / 5);
    }
    return 0;
  }

  getTripPerformanceStripStyle(trip: any): { [key: string]: string } {
    const rows = this.getTripPerformanceRows(trip);
    if (rows <= 0) return { display: 'none' };

    const px = this.tripSheetRowPx;
    return {
      top: `calc(-${rows} * ${px}px)`,
      height: `calc(${rows} * ${px}px)`,
    };
  }

  /** Dashed outline top offset must match cushion strip. */
  getTripCushionOutlineStyle(trip: any): { [key: string]: string } {
    if (trip.isBreakTrip) {
      return {};
    }
    const rows = this.getTripCushionRows(trip);
    return { top: `calc(-${rows} * ${this.tripSheetRowPx}px)` };
  }


  getStartPoint(date, b = true) {
    const time = moment(date).tz(this.timeZone);
    const totalMinutes = time.hours() * 60 + time.minutes();
    const slotIndex = Math.floor(totalMinutes / 5);

    // Row 1 is the 1.75rem header. 00:00 starts at Row 2.
    // If b is false (used for durations/offsets), we return the raw slot index + 1?
    // Actually, for duration span, we should use a separate method.
    return slotIndex + (b ? 2 : 1);
  }

  getEndPoint(dateOne, dateTwo) {
    const time1 = moment(dateOne).tz(this.timeZone);
    const time2 = moment(dateTwo).tz(this.timeZone);
    let diffInMinutes = time2.diff(time1, 'minutes');
    if (diffInMinutes < 5) diffInMinutes = 5;
    return Math.ceil(diffInMinutes / 5);
  }


  getShiftStartPoint(date, b = true) {
    const modifiedDate = moment(date, 'HHmm').toISOString();
    return this.getStartPoint(modifiedDate, b);
  }


  getShiftEndPoint(dateOne, dateTwo) {
    const modifiedDate1 = moment(dateOne, 'HHmm').toISOString();
    const modifiedDate2 = moment(dateTwo, 'HHmm').toISOString();
    return this.getEndPoint(modifiedDate1, modifiedDate2);
  }

  openDetailModal(trip) {
    this.tripDetailModalObj = trip
  }

  async onTripDropped(event: CdkDragDrop<any>) {
    const trip = event.item.data;
    const driverId = event.container.data;
    const previousDriverId = event.previousContainer.data;

    if (driverId && driverId.startsWith('empty_')) {
      return;
    }

    if (this.isMultiTripDrag(event)) {
      await this.onMultiTripDropped(event);
      return;
    }

    // Same column: attempt Y-axis time reschedule (only for unassigned/offered)
    if (driverId === previousDriverId) {
      if (
        driverId !== 'no_driver' &&
        (trip.status === 'unassigned' || trip.status === 'offered') &&
        Math.abs(event.distance.y) >= this.tripSheetRowPx
      ) {
        this.initiateTimeReschedule(trip, event.distance.y);
      }
      return;
    }

    const targetDriver = (this.preDriverList as any)[driverId];
    const alertMessage = this.getAlertMessage(driverId, targetDriver);

    // Capture pre-state for undo
    const prevDriverId = trip.driver
      ? (typeof trip.driver === 'object' ? trip.driver._id : trip.driver)
      : null;
    const prevStatus: string = trip.status;
    const prevJobStatus: string = trip.jobStatus;
    const prevDriverObj = trip.driver ? (typeof trip.driver === 'object' ? { ...trip.driver } : (this.preDriverList as any)[trip.driver]) : null;
    const prevDriverName = prevDriverObj ? prevDriverObj.displayName : 'Unassigned';

    let result: any = { value: true };
    if (driverId === 'no_driver') {
      result = await sweetAlert('Alert', alertMessage, 'warning', 'Yes', 'No');
    }
    if (result.value) {

      // Assign to a driver
      // Push undo entry before mutating
      this.undoStack.push({ type: 'assign', trip, prevDriverId, prevStatus, prevJobStatus, driverName: prevDriverName });
      this.cdr.markForCheck();

      if (driverId === 'no_driver') {
        trip.jobStatus = 'pending';
        trip.status = 'unassigned';
        trip.driver = null; // Clear driver
        this.updateSingleTrip(trip);
      } else {
        const fullDriver = (this.preDriverList as any)[driverId];
        trip.driver = fullDriver ? { ...fullDriver } : { _id: driverId };
        trip.status = 'offered';
        trip.jobStatus = 'offered';
        this.assignSingleTrip(trip);
      }

      // Update in allTrips so filtration picks it up
      const tripIndex = this.allTrips.findIndex(t => t._id === trip._id);
      if (tripIndex !== -1) {
        this.allTrips[tripIndex] = trip;
        this.prepareDataFilters();
      }

    }
  }
  viewCompletedTripDetails(trip) {
    this.completedTripModalObj = trip;
  }



  showFilter() {
    this.showSlideFilter = !this.showSlideFilter;
  }

  closeFilter() {
    this.showSlideFilter = false;
  }

  showDriverBreak(val) {
    this.showBreak = val
    this.getRefreshTrips();
  }

  onResetTime() {
    this.todayDate = [
      moment(this.todayDate[0]).startOf("day").toISOString(),
      moment(this.todayDate[1]).endOf("day").toISOString(),
    ];
    this.getRefreshTrips();
  }
  onTimeChange(event) {
    this.driversTimelines = {};
    this.preShiftOverrides = {};
    // debugger;
    this.todayDate = [
      event[0].toISOString(),
      event[1].toISOString(),
    ];
    this.getRefreshTrips();
  }

  onDateChange(event) {
    this.singleDate = event.toISOString();
    this.todayDate = [
      event.startOf("day").toISOString(),
      event.endOf("day").toISOString(),
    ];
    this.updateCurrentTimePosition();
    this.driversTimelines = {};
    this.preShiftOverrides = {};
    if (!this.isTodaySelected()) {
      this.activeDriversOnly = false;
    }
    // this.todayDate =
    //   [
    //     event[0].toISOString(),
    //     event[1].endOf("day").toISOString(),
    //   ]
    this.isAllowToHover = false;
    this.getRefreshTrips();
    this.getDriversTimelines();
  }

  getTimeRestrictions() {
    return { min: moment(this.todayDate[0]).tz(this.timeZone).startOf("day").toISOString(), max: moment(this.todayDate[1]).tz(this.timeZone).endOf("day").toISOString() }
  }



  getViolationData() {
    this.violationService.getViolationData()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.violations = data;
          this.cdr.markForCheck();
        }
      });
  }

  toggleStatusDropdown() {
    this.isShowStatusDropdown = !this.isShowStatusDropdown
  }

  onChangeStatus() {
    this.isAllowToHover = false;
    this.getRefreshTrips();
  }

  getShiftOverrides() {
    const payload = {
      startDate: moment(this.todayDate[0]).tz(this.timeZone).startOf('day').toISOString(),
      endDate: moment(this.todayDate[1]).tz(this.timeZone).endOf('day').toISOString(),
      status: 'active'
    }
    this.driverService.getShiftOverridesByDate(payload).subscribe(data => {
      this.preShiftOverrides = data.reduce((obj, item) => {
        if (item.driver && item.driver._id) {
          if (!obj[item.driver._id]) {
            obj[item.driver._id] = [];
          }
          obj[item.driver._id].push(item);
        }
        return obj;
      }, {});
      this.cdr.markForCheck();
    });
  }

  getDriverShift(driver) {
    if (!driver) return null;
    const currentDay = moment(this.todayDate[0]).tz(this.timeZone).day();
    const shifts = driver.profileRole === 'assist' ? driver.assistShifts : driver.shifts;
    if (shifts && shifts.length) {
      return shifts.find(shift => shift.day === currentDay && shift.isEnabled);
    }
    return null;
  }

  getShiftTimeRange(shift: any): string {
    if (!shift) return '';
    const data = shift.shift || shift;
    const start = data.checkin || data.startTime;
    const end = data.checkout || data.endTime;

    const formatTime = (time: any) => {
      if (!time) return '??:??';

      // If it's already HH:mm format, return it as is
      if (typeof time === 'string' && /^([01]\d|2[0-3]):[0-5]\d$/.test(time)) {
        return moment(time, 'HH:mm').format(this.timeFormat);
      }

      // Handle HHmm format (e.g., "0800")
      if (typeof time === 'string' && time.length === 4 && /^\d+$/.test(time)) {
        return moment(time, 'HHmm').format(this.timeFormat);
      }

      // Handle ISO strings or other date objects
      const m = moment(time);
      if (m.isValid()) {
        return m.tz(this.timeZone).format(this.timeFormat);
      }

      return '??:??';
    };

    return `${formatTime(start)} - ${formatTime(end)}`;
  }

  formatMins(mins: number): string {
    if (!mins || mins <= 0) return '0 min';
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    return h > 0 ? `${h}h ${m}m` : `${m} min`;
  }

  selectShift(driverId, shift, type) {
    this.selectedShifts[driverId] = { shift, type };
    this.cachedShiftBreakdowns[driverId] = this.computeShiftBreakdown(driverId);
    this.updateDriverTripOutsideFlags(driverId);
    this.cdr.markForCheck();
  }

  updateDriverTripOutsideFlags(driverId: string) {
    const trips = this.driverTrips[driverId] || [];
    const breakdown = this.cachedShiftBreakdowns[driverId];
    if (breakdown) {
      let s = Infinity;
      let e = -Infinity;
      Object.values(breakdown).forEach((window: any) => {
        s = Math.min(s, window.start);
        e = Math.max(e, window.start + window.end);
      });
      trips.forEach(trip => {
        const tripRow = this.getStartPoint(trip.scheduleTime, true);
        trip._isOutsideShift = tripRow < s || tripRow >= e;
      });
    } else {
      trips.forEach(trip => {
        trip._isOutsideShift = false;
      });
    }
  }

  normalizeShift(shift, type) {
    if (!shift) return null;
    if (type === 'override' && shift.isEnabled === true) {
      return null;
    }
    let checkin, checkout;

    if (type === 'actual') {
      // Actual shifts come in ISO format
      checkin = shift.checkin;
      checkout = shift.checkout;
    } else if (type === 'regular' || type === 'override') {
      const shiftData = type === 'override' ? shift.shift : shift;
      if (!shiftData || !shiftData.checkin) return null;

      const datePart = moment(this.todayDate[0]).format('YYYY-MM-DD');
      checkin = moment.tz(`${datePart} ${shiftData.checkin}`, 'YYYY-MM-DD HH:mm', this.timeZone).toISOString();
      checkout = moment.tz(`${datePart} ${shiftData.checkout}`, 'YYYY-MM-DD HH:mm', this.timeZone).toISOString();
    }

    return { checkin, checkout };
  }

  getDriversTimelines() {
    const queryString = {};
    const range = [moment(this.todayDate[0]).startOf("day").toISOString(), moment(this.todayDate[1]).endOf("day").toISOString()];
    queryString['dates'] = { "startDate": range[0], "endDate": range[1] };
    this.driverService
      .getAllDriverTimelines(queryString)
      .subscribe(data => {
        if (data && data.length) {
          this.driversTimelines = data.reduce((acc, item) => {
            const { _id, jobs } = item;
            const driverId = _id.driver;
            const sessions: any[] = [];
            if (jobs && jobs.length) {
              jobs.forEach(job => {
                if (job.sessions && job.sessions.length) {
                  job.sessions.forEach(session => {
                    sessions.push({
                      checkin: session.checkin,
                      checkout: session.checkout || null
                    });
                  });
                } else if (job.checkin) {
                  sessions.push({
                    checkin: job.checkin,
                    checkout: job.checkout || null
                  });
                }
              });
            }
            sessions.sort((a, b) => {
              if (!a.checkin) return 1;
              if (!b.checkin) return -1;
              return moment(a.checkin).diff(moment(b.checkin));
            });
            acc[driverId] = sessions;
            return acc;
          }, {});
          this.rebuildCaches();
          this.cdr.markForCheck();
        }
      });
  }

  getDriverCompletedWorkTimeInMillis(driverId: string, currentSessionCheckin?: string): number {
    const sessions = this.driversTimelines[driverId];
    if (!sessions || !Array.isArray(sessions)) return 0;

    let total = 0;
    sessions.forEach(session => {
      if (currentSessionCheckin && session.checkin === currentSessionCheckin) {
        return;
      }
      if (session.checkin && session.checkout) {
        const diff = moment(session.checkout).diff(moment(session.checkin));
        if (diff > 0) {
          total += diff;
        }
      }
    });
    return total;
  }

  shiftBreakdown(driverId) {
    const selected = this.selectedShifts[driverId];
    // Selected "Not Available" override: no timeline strip — do not fall through to actual/scheduled shift.
    if (selected && selected.type === 'override' && selected.shift && selected.shift.isEnabled === true) {
      return null;
    }
    let shift;
    if (selected) {
      shift = this.normalizeShift(selected.shift, selected.type);
    } else {
      shift = this.driversTimelines[driverId];
    }
    const driverTrips = this.driverTrips[driverId] || [];
    const breakdown = {};

    // 1. Check if we have Shift data (Selected or Default Actual)
    if (shift && !Array.isArray(shift) && shift.checkin) {
      let { checkin, checkout } = shift;
      const checkinMoment = moment(checkin).tz(this.timeZone);
      const checkinHours = checkinMoment.format("HHmm");

      if (!checkout) {
        // Active Shift (Not Ended)
        const completedTime = this.getDriverCompletedWorkTimeInMillis(driverId, checkin);
        if (completedTime > 8 * 60 * 60 * 1000) {
          // If completed time is more than 8 hours, we don't calculate the remainingTargetTime target.
          // Consider it as an overtime and its supposed checkout time is the day end.
          breakdown['shift_started.overtime_window'] = {
            start: this.getShiftStartPoint(checkinHours, true),
            end: this.getShiftEndPoint(checkinHours, "2359")
          };
        } else {
          const remainingTargetTime = 8 * 60 * 60 * 1000 - completedTime;
          const supposedCheckout = checkinMoment.clone().add(remainingTargetTime, 'milliseconds');
          const supposedCheckoutHours = supposedCheckout.format("HHmm");

          breakdown['shift_started.regular_window'] = {
            start: this.getShiftStartPoint(checkinHours, true),
            end: this.getShiftEndPoint(checkinHours, supposedCheckoutHours)
          };

          // Check for Overtime if trips exist beyond supposed checkout
          if (driverTrips.length) {
            const lastTrip = driverTrips[driverTrips.length - 1];
            const apt = moment(lastTrip.appointmentTime || moment(lastTrip.scheduleTime).add(30, 'm')).tz(this.timeZone);
            if (apt.isAfter(supposedCheckout)) {
              breakdown['shift_started.overtime_window'] = {
                start: this.getShiftStartPoint(supposedCheckoutHours, true),
                end: this.getShiftEndPoint(supposedCheckoutHours, apt.format("HHmm"))
              };
            }
          }
        }
      } else {
        // Completed Shift
        const checkoutMoment = moment(checkout).tz(this.timeZone);
        const checkoutHours = checkoutMoment.format("HHmm");
        const totalHoursWorked = checkoutMoment.diff(checkinMoment, 'hours', true);

        breakdown['shift_ended.regular_window'] = {
          start: this.getShiftStartPoint(checkinHours, true),
          end: this.getShiftEndPoint(checkinHours, checkoutHours)
        };
      }
      return breakdown;
    }

    // 2. Fallback to Scheduled Shift if not checked in
    const driver = this.driverList.find(d => d._id === driverId);
    if (driver && driver.shifts) {
      const now = moment(this.todayDate[0]).tz(this.timeZone);
      const scheduledShift = driver.shifts.find(s => s.isEnabled && s.day === now.day());

      if (scheduledShift && scheduledShift.checkin && scheduledShift.checkout) {
        breakdown['shift_started.regular_window'] = {
          start: this.getShiftStartPoint(scheduledShift.checkin, true),
          end: this.getShiftEndPoint(scheduledShift.checkin, scheduledShift.checkout)
        };
        return breakdown;
      }
    }

    return null;
  }


  getAlertMessage(zoneId: string, targetDriver: any): string {
    return zoneId === 'no_driver'
      ? 'Are you sure you want to unassign this trip?'
      : `Are you sure you want to assign this trip to ${targetDriver.displayName}?`;
  }



  assignSingleTrip(payload) {

    this.assignTripService
      .assignTrip(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  updateSingleTrip(payload) {
    this.assignTripService
      .updateTrip(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  undoLastAssignment() {
    if (!this.undoStack.length) return;
    const entry = this.undoStack.pop()!;

    if (entry.type === 'multiAssign') {
      this.undoMultiAssignment(entry.tripIds || []);
      return;
    }

    const trips: any[] = this.allTrips as any[];
    const tripIndex = trips.findIndex((t: any) => t._id === entry.trip._id);
    const liveTripObj: any = tripIndex !== -1 ? trips[tripIndex] : entry.trip;

    if (entry.type === 'reschedule') {
      liveTripObj.scheduleTime = entry.prevScheduleTime;
      liveTripObj.appointmentTime = entry.prevAppointmentTime;

      if (tripIndex !== -1) {
        trips[tripIndex] = { ...liveTripObj };
      }

      this.prepareDataFilters();
      this.cdr.markForCheck();
      this.updateSingleTrip({ ...liveTripObj });
      return;
    }

    // type === 'assign'
    const prevDriverObj = entry.prevDriverId
      ? (this.preDriverList as any)[entry.prevDriverId]
      : null;

    liveTripObj.driver = prevDriverObj ? { ...prevDriverObj } : null;
    liveTripObj.status = entry.prevStatus;
    liveTripObj.jobStatus = entry.prevJobStatus;

    if (tripIndex !== -1) {
      trips[tripIndex] = { ...liveTripObj };
    }

    this.prepareDataFilters();
    this.cdr.markForCheck();

    const payload = { ...liveTripObj };
    if (entry.prevDriverId) {
      this.assignSingleTrip(payload);
    } else {
      payload.driver = null;
      this.updateSingleTrip(payload);
    }
  }

  onClickTripCard(trip) {
    if (this.editTripModalObj || this.isDetailsModalOpen) return; // if edit action is clicked
    if (trip.isBreakTrip) return;
    if (trip.status === 'unassigned' || trip.status === 'offered' || trip.status === 'accepted') {
      this.openAssignModal(trip);
    } else {
      if (trip.job) {
        this.viewCompletedTripDetails(trip);
      } else {
        this.openDetailModal(trip);
      }
    }
  }

  onColumnMouseMove(event: MouseEvent, colIndex: number) {
    const ol = event.currentTarget as HTMLElement;
    const rect = ol.getBoundingClientRect();
    const y = event.clientY - rect.top;

    // If we're hovering above the grid (e.g in the top margin of the card space), hide highlight.
    if (y < 64) {
      this.hoveredColumnIndex = -1;
      return;
    }

    const gridY = y - 64;
    // Calculate which 5-min slot this pixel height maps to
    const slotIndex = Math.floor(gridY / 7.619);

    // Snap to 30-min block boundaries (6 slots per block)
    const blockIndex = Math.floor(slotIndex / 6);

    // Row 1 is the 64px header, so row 2 is 00:00
    this.hoveredRowStart = (blockIndex * 6) + 2;

    // Update dotted highlight instantly (this can change on every row move)
    if (this.hoveredRowStart !== slotIndex + 2 || this.hoveredColumnIndex !== colIndex) {
      this.hoveredRowStart = slotIndex + 2;
      this.hoveredColumnIndex = colIndex;

      // Expansion Logic: Only reset the timer if the target COLUMN changes.
      // Moving mouse vertically inside the same column will NOT reset the 1s timer.
      if (this.isHoverExpansionEnabled && this.expandedColumnIndex !== colIndex) {
        if (this.lastTimerColIndex !== colIndex) {
          if (this.expansionTimer) clearTimeout(this.expansionTimer);
          this.lastTimerColIndex = colIndex;
          this.expansionTimer = setTimeout(() => {
            this.expandedColumnIndex = colIndex;
            this.cdr.markForCheck();
          }, 1500);
        }
      } else if (!this.isHoverExpansionEnabled || this.expandedColumnIndex === colIndex) {
        // We are already expanded here, or expansion is disabled, make sure no timer is accidentally running
        if (this.expansionTimer) {
          clearTimeout(this.expansionTimer);
          this.expansionTimer = null;
          this.lastTimerColIndex = -1;
        }
      }
      this.cdr.markForCheck();
    }
  }

  onColumnMouseLeave() {
    this.hoveredColumnIndex = -1;
    this.expandedColumnIndex = -1;
    this.lastTimerColIndex = -1;
    if (this.expansionTimer) {
      clearTimeout(this.expansionTimer);
      this.expansionTimer = null;
    }
    this.cdr.markForCheck();
  }

  onHeaderMouseEnter(colIndex: number) {
    this.hoveredColumnIndex = colIndex;
    if (this.isHoverExpansionEnabled && this.expandedColumnIndex !== colIndex) {
      if (this.lastTimerColIndex !== colIndex) {
        if (this.expansionTimer) clearTimeout(this.expansionTimer);
        this.lastTimerColIndex = colIndex;
        this.expansionTimer = setTimeout(() => {
          this.expandedColumnIndex = colIndex;
          this.cdr.markForCheck();
        }, 1500);
      }
    }
    this.cdr.markForCheck();
  }

  onTripMouseEnter(tripId: string) {
    this.hoveredTripId = tripId;
    this.cdr.markForCheck();
  }

  onTripMouseLeave() {
    this.hoveredTripId = null;
    this.cdr.markForCheck();
  }

  onHoverExpansionChange() {
    localStorage.setItem('tripSheet_hoverExpansionEnabled', String(this.isHoverExpansionEnabled));
    if (!this.isHoverExpansionEnabled) {
      this.expandedColumnIndex = -1;
      this.lastTimerColIndex = -1;
      if (this.expansionTimer) {
        clearTimeout(this.expansionTimer);
        this.expansionTimer = null;
      }
    }
    this.cdr.markForCheck();
  }

  ngOnDestroy(): void {
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
    this.undoStack = [];

    Object.keys(this.inlineTimeDebounceTimers).forEach(key => clearTimeout(this.inlineTimeDebounceTimers[key]));
    Object.keys(this.justSavedFieldTimers).forEach(key => clearTimeout(this.justSavedFieldTimers[key]));
  }

  getDisplayDrivers() {
    return this.cachedDisplayDrivers;
  }

  computeDisplayDrivers(): string[] {
    const filteredSet = new Set((this.filteredDrivers || []).map(d => d._id));
    let result = (this.driverList as any[])
      .filter(d => filteredSet.has(d._id))
      .map(d => d._id as string);

    if (this.activeDriversOnly && this.isTodaySelected()) {
      result = result.filter(driverId => !this.hasNoTrips(driverId));
    }

    while (result.length < this.driversPerPage) {
      result.push(`empty_${result.length}`);
    }

    return result;
  }

  isTodaySelected(): boolean {
    if (!this.singleDate) return false;
    return moment(this.singleDate).tz(this.timeZone).isSame(moment().tz(this.timeZone), 'day');
  }

  onActiveDriversOnlyChange() {
    this.rebuildCaches();
    this.cdr.markForCheck();
  }

  onLimitChange() {
    let n = Number(this.driversPerPage);
    if (isNaN(n)) {
      n = this.driversPerPageMin;
    }
    n = Math.max(
      this.driversPerPageMin,
      Math.min(this.driversPerPageMax, n)
    );
    n = Math.round(n / this.driversPerPageStep) * this.driversPerPageStep;
    n = Math.max(
      this.driversPerPageMin,
      Math.min(this.driversPerPageMax, n)
    );
    this.driversPerPage = n;
    localStorage.setItem('tripSheet_driversPerPage', String(this.driversPerPage));
  }

  incrementDriversPerPage() {
    const next = this.driversPerPage + this.driversPerPageStep;
    if (next <= this.driversPerPageMax) {
      this.driversPerPage = next;
      this.onLimitChange();
    }
  }

  decrementDriversPerPage() {
    const next = this.driversPerPage - this.driversPerPageStep;
    if (next >= this.driversPerPageMin) {
      this.driversPerPage = next;
      this.onLimitChange();
    }
  }

  getDriverName(driverId: string) {
    if (driverId === 'no_driver') return 'Unassigned';
    if (driverId.startsWith('empty_')) return '';
    const driver = this.preDriverList[driverId];
    return (driver && driver.displayName) || 'Unknown';
  }

  getDriverImage(driverId: string) {
    if (driverId === 'no_driver' || driverId.startsWith('empty_')) {
      return 'assets/images/placeholders/driver-placeholder.png';
    }
    const driver = this.preDriverList[driverId];
    return (driver && driver.profileImageURL) || 'assets/images/placeholders/driver-placeholder.png';
  }

  getDriverRigNumber(driverId: string) {
    if (driverId === 'no_driver' || driverId.startsWith('empty_')) return 'N/A';
    const driver = this.preDriverList[driverId];
    if (driver && driver.fleet && driver.fleet.setiDecall) {
      return driver.fleet.setiDecall;
    }
    return 'N/A';
  }

  async calculateDistance(lat1, lon1, lat2, lon2) {
    let resutl;
    if (this.isGoogleMiles) {
      resutl = await this.calculateDistanceWithGIS(lat1, lon1, lat2, lon2);
    } else {
      resutl = await new Promise((resolve) => { resolve(getDistanceFromLatLon(lat1, lon1, lat2, lon2)) });
    }
    return resutl;
  }

  async calculateDistanceWithGIS(lat1, lon1, lat2, lon2) {
    const res: any = await this.assignTripService.getRoutingDistance(lat1, lon1, lat2, lon2).toPromise();
    const segments: any = res.features[0].properties.segments;
    return {
      distance: (segments[0].distance / 1609),
      duration: Math.floor(segments[0].duration / 60)
    };
  }

  // ─── Tooltip ─────────────────────────────────────────────────────────────────
  /** Native tooltip (title) for trip row hover — returns cached string (not async). */
  getTripCardTitle(trip: any) {
    if (!trip || !trip._id) return null;
    return this.cachedTripTitles[trip._id] || null;
  }


  getDriverColumnCount() {
    return this.cachedDriverColumnCount;
  }

  computeDriverColumnCount(): number {
    const total = (this.filteredDrivers || []).length;
    return Math.max(total, this.driversPerPage);
  }

  trackByDriverId(index: number, driverId: string) {
    return driverId;
  }

  trackByTripId(_index: number, trip: any) {
    return trip._id;
  }

  /**
   * One column per driver; overlapping trips split width by subTotal (e.g. 2 → 50% / 50%).
   * Avoids repeat(globalMaxSubTotal) which left empty tracks when another part of the day had more overlaps.
   */
  getTripGridItemStyle(trip: any): { [key: string]: string } {
    const cached = this.cachedTripGridStyles[trip._id];
    if (cached) return cached;
    return this.computeTripGridItemStyle(trip);
  }

  computeTripGridItemStyle(trip: any): { [key: string]: string } {
    const subTotal = trip.subTotal || 1;
    const subIndex = trip.subIndex || 0;
    const gridRow =
      this.getStartPoint(trip.scheduleTime, true) +
      ' / span ' +
      this.getEndPoint(trip.scheduleTime, trip.appointmentTime);
    const style: { [key: string]: string } = {
      'grid-row': gridRow,
      'grid-column': '1 / -1',
      'justify-self': 'start',
      'z-index': String(subIndex + 1),
      'box-sizing': 'border-box',
    };
    if (subTotal <= 1) {
      style['width'] = '100%';
      style['margin-left'] = '0%';
    } else {
      style['width'] = 100 / subTotal + '%';
      style['margin-left'] = (100 / subTotal) * subIndex + '%';
    }
    this.cachedTripGridStyles[trip._id] = style;
    return style;
  }

  initiateTimeReschedule(trip: any, deltaY: number) {
    const minutesDelta = Math.round(deltaY / this.tripSheetRowPx) * 5;
    if (minutesDelta === 0) return;

    const oldMoment = (moment as any)(trip.scheduleTime).tz(this.timeZone);
    const newMoment = oldMoment.clone().add(minutesDelta, 'minutes');

    // Prevent dropping/rescheduling before 00:00 of the same day
    const startOfDay = oldMoment.clone().startOf('day');
    if (newMoment.isBefore(startOfDay)) {
      return;
    }

    const newScheduleTime = newMoment.toISOString();
    const newAppointmentTime = trip.appointmentTime
      ? (moment as any)(trip.appointmentTime).tz(this.timeZone).add(minutesDelta, 'minutes').toISOString()
      : null;

    this.timeRescheduleModalObj = {
      trip,
      oldScheduleTime: trip.scheduleTime,
      oldAppointmentTime: trip.appointmentTime || null,
      newScheduleTime,
      newAppointmentTime,
      oldTimeDisplay: oldMoment.format(this.timeFormat),
      newTimeDisplay: newMoment.format(this.isAmPmFormat() ? 'hhmm' : 'HHmm'),
      newMeridiem: newMoment.format('A')
    };
  }

  /** Lets the user type a new "To" time directly in the reschedule modal instead of only accepting the
   * dragged-to time. Self-contained: reuses parseInlineTimeInput for validation but doesn't touch
   * initiateTimeReschedule above, so the drag flow is unaffected. Applies the same day-boundary limit
   * as the drag path and carries the appointment time forward by the same offset. */
  onRescheduleTimeInput(event: any) {
    if (!this.timeRescheduleModalObj) return;
    // In 12-hour mode the input holds "hhmm" and the AM/PM comes from the toggle — convert to "HHmm" first.
    const parsed = this.parseInlineTimeInput(this.isAmPmFormat()
      ? moment(event.target.value + this.timeRescheduleModalObj.newMeridiem, 'hhmmA', true).format('HHmm')
      : event.target.value);
    if (!parsed) return;

    const { trip } = this.timeRescheduleModalObj;
    const oldMoment = (moment as any)(trip.scheduleTime).tz(this.timeZone);
    const newMoment = oldMoment.clone().set({ hour: parsed.hours, minute: parsed.minutes, second: 0, millisecond: 0 });
    if (newMoment.isBefore(oldMoment.clone().startOf('day'))) return;

    this.timeRescheduleModalObj = {
      ...this.timeRescheduleModalObj,
      newScheduleTime: newMoment.toISOString(),
      newAppointmentTime: trip.appointmentTime
        ? newMoment.clone().add((moment as any)(trip.appointmentTime).diff(oldMoment), 'milliseconds').toISOString()
        : null,
      newTimeDisplay: newMoment.format(this.isAmPmFormat() ? 'hhmm' : 'HHmm'),
      newMeridiem: newMoment.format('A')
    };
  }

  /** Flips AM/PM on the reschedule "To" time, applied to its last valid value. */
  toggleRescheduleMeridiem() {
    if (!this.timeRescheduleModalObj) return;
    const { newTimeDisplay, newMeridiem } = this.timeRescheduleModalObj;
    this.timeRescheduleModalObj = { ...this.timeRescheduleModalObj, newMeridiem: newMeridiem === 'AM' ? 'PM' : 'AM' };
    this.onRescheduleTimeInput({ target: { value: newTimeDisplay } });
  }

  /** Resyncs the "To" input's displayed text if the user left it on an incomplete/invalid value. */
  onRescheduleTimeBlur(event: any) {
    if (!this.timeRescheduleModalObj) return;
    // Every valid value is applied as it's typed, so anything still differing here is empty or invalid —
    // same messages as the inline time edit on Unassigned Trips cards.
    const value = (event.target.value || '').trim();
    if (value !== this.timeRescheduleModalObj.newTimeDisplay) {
      this.toastr.error(value
        ? 'Invalid time format. Use ' + (this.isAmPmFormat() ? 'hhmm (e.g. 0230)' : 'HHmm (e.g. 1430)')
        : 'Time cannot be empty', 'Error');
    }
    event.target.value = this.timeRescheduleModalObj.newTimeDisplay;
  }

  confirmTimeReschedule() {
    if (!this.timeRescheduleModalObj) return;
    const { trip, newScheduleTime, newAppointmentTime, oldScheduleTime, oldAppointmentTime } = this.timeRescheduleModalObj;

    // Push undo entry before mutating
    const prevDriverId = trip.driver
      ? (typeof trip.driver === 'object' ? trip.driver._id : trip.driver)
      : null;
    const prevDriverObj = trip.driver
      ? (typeof trip.driver === 'object' ? trip.driver : (this.preDriverList as any)[trip.driver])
      : null;
    this.undoStack.push({
      type: 'reschedule',
      trip,
      prevDriverId,
      prevStatus: trip.status,
      prevJobStatus: trip.jobStatus,
      driverName: prevDriverObj ? prevDriverObj.displayName : 'Unassigned',
      prevScheduleTime: oldScheduleTime,
      prevAppointmentTime: oldAppointmentTime
    });
    this.cdr.markForCheck();

    const trips = this.allTrips as any[];
    const tripIndex = trips.findIndex((t: any) => t._id === trip._id);
    if (tripIndex !== -1) {
      trips[tripIndex] = {
        ...trips[tripIndex],
        scheduleTime: newScheduleTime,
        appointmentTime: newAppointmentTime
      };
      this.prepareDataFilters();
    }

    // Same update-trip API (and saving/toast/revert behavior) the inline time edit on
    // Unassigned Trips cards uses via updateTrip(), so both flows stay consistent.
    const payload = { ...trip, scheduleTime: newScheduleTime, appointmentTime: newAppointmentTime };
    this.savingTripId = trip._id;
    this.cdr.markForCheck();

    this.assignTripService
      .createNewTripV2(payload, trip._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        data => {
          this.clearSavingIndicator(trip._id);
          if (data) {
            this.toastr.success('Time updated successfully', 'Success');
          }
        },
        err => {
          this.clearSavingIndicator(trip._id);
          // Roll back the optimistic update and drop the now-invalid undo entry
          if (tripIndex !== -1) {
            trips[tripIndex] = {
              ...trips[tripIndex],
              scheduleTime: oldScheduleTime,
              appointmentTime: oldAppointmentTime
            };
            this.prepareDataFilters();
          }
          this.undoStack.pop();
          this.cdr.markForCheck();
          this.toastr.error('Failed to update time', 'Error');
        }
      );
    this.timeRescheduleModalObj = null;
  }

  cancelTimeReschedule() {
    this.timeRescheduleModalObj = null;
  }



  openAssignModal(trip) {
    this.closeInlineTimeEdit(trip);
    this.assignModalObj = trip;
    this.componentType = 'unassign';
  }

  onAssignTrip(evt) {
    if (evt) {
      this.assignModalObj = null;
      this.getRefreshTrips();
    }
  }

  onCloseAssignModal() {
    this.assignModalObj = null;
  }

  openDriverTripDetailModal(id) {
    this.driverTripModalObj = id;
  }

  closeModal(evt) {
    this.driverTripModalObj = null;
  }

  driverBreak(driverIdOrDriver, breakObj?) {
    let driver;
    if (typeof driverIdOrDriver === 'object' && driverIdOrDriver !== null) {
      driver = driverIdOrDriver;
    } else {
      driver = (this.preDriverList && this.preDriverList[driverIdOrDriver])
        || this.drivers.find(d => d._id === driverIdOrDriver);
    }

    const targetDate = this.singleDate || (Array.isArray(this.todayDate) ? this.todayDate[0] : this.todayDate) || moment();

    this.breakModalObj = {
      driver: driver,
      break: breakObj,
      date: targetDate
    };
    this.cdr.markForCheck();
  }

  driverBreakPayload(payload) {
    this.breakService.addDriverBreak(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        data => {
          if (data) {
            this.onBreakModelClose();
          }
        },
        err => {
          sweetAlert('Error', err, 'warning', 'OK');
        }
      );
  }

  onBreakModelClose() {
    this.breakModalObj = null;
    this.cdr.markForCheck();
    this.getRefreshTrips();
  }

  toggleTimer() {
    this.isTimerEnabled = !this.isTimerEnabled;
    if (this.isTimerEnabled) {
      this.getRefreshTrips();
    } else {
      this.timer.init();
    }
  }

  onTimerComplete(): void {
    this.timer.init();
    this.getRefreshTrips();
  }

  onChangeMilesCalculation() {
    this.getRefreshTrips();
  }


  /**
   * Rebuild all cached values used by template getters.
   * Called once after filterTrips() finishes, so Angular's CD reads stable values.
   */
  rebuildCaches() {
    // Sync driversPerPage with current selection to ensure columns fit correctly.
    const selectedCount = (this.selectedDriver || []).length;
    if (selectedCount > 0) {
      this.driversPerPage = Math.max(this.driversPerPageMin || 5, selectedCount);
    }

    // 1. Display drivers & column count
    this.cachedDisplayDrivers = this.computeDisplayDrivers();
    this.cachedDriverColumnCount = this.computeDriverColumnCount();

    // Re-bind selected actual shift references to the new session objects from driversTimelines
    for (const driverId of this.cachedDisplayDrivers) {
      if (!driverId.startsWith('empty_')) {
        const selected = this.selectedShifts[driverId];
        if (selected && selected.type === 'actual' && selected.shift) {
          const sessions = this.driversTimelines[driverId] || [];
          const matchedSession = sessions.find(s => s.checkin === selected.shift.checkin);
          if (matchedSession) {
            selected.shift = matchedSession;
          }
        }
      }
    }

    // 2. Initialize default shift selections for drivers
    for (const driverId of this.cachedDisplayDrivers) {
      if (!driverId.startsWith('empty_') && !this.selectedShifts[driverId]) {
        const driver = this.preDriverList[driverId];
        if (driver && this.getDriverShift(driver)) {
          this.selectedShifts[driverId] = { shift: this.getDriverShift(driver), type: 'regular' };
        }
      }
    }

    // 3. Shift breakdowns per driver
    const breakdowns: { [driverId: string]: any } = {};
    for (const driverId of this.cachedDisplayDrivers) {
      if (!driverId.startsWith('empty_')) {
        breakdowns[driverId] = this.computeShiftBreakdown(driverId);
      }
    }
    this.cachedShiftBreakdowns = breakdowns;

    // 3. Trip grid styles + outside-shift flag (uses cachedShiftBreakdowns built above)
    this.cachedTripGridStyles = {};
    for (const driverId of Object.keys(this.driverTrips)) {
      const trips = this.driverTrips[driverId];
      if (trips && trips.length) {
        const breakdown = this.cachedShiftBreakdowns[driverId];
        for (const trip of trips) {
          this.computeTripGridItemStyle(trip);
          if (breakdown) {
            const tripRow = this.getStartPoint(trip.scheduleTime, true);
            let s = Infinity, e = -Infinity;
            Object.values(breakdown).forEach((w: any) => { s = Math.min(s, w.start); e = Math.max(e, w.start + w.end); });
            trip._isOutsideShift = tripRow < s || tripRow >= e;
          } else {
            trip._isOutsideShift = false;
          }
        }
      }
    }

    // 4. Tooltip titles — precompute synchronous part, async parts fill in later
    this.precomputeTripTitles();
  }

  /**
   * Cached shiftBreakdown accessor for template.
   */
  getCachedShiftBreakdown(driverId: string): any {
    return this.cachedShiftBreakdowns[driverId] || null;
  }

  /**
   * Actual shift breakdown computation — moved from shiftBreakdown() to avoid template recomputing.
   */
  computeShiftBreakdown(driverId: string) {
    return this.shiftBreakdown(driverId);
  }

  /**
   * Precompute tooltip titles for all visible trips.
   */
  precomputeTripTitles() {
    this.cachedTripTitles = {};
    for (const driverId of Object.keys(this.driverTrips)) {
      const trips = this.driverTrips[driverId];
      if (!trips) continue;
      for (const trip of trips) {
        if (trip && trip._id && trip.scheduleTime) {
          // Build sync tooltip immediately
          this.cachedTripTitles[trip._id] = this.buildTripTooltipSync(trip);
        }
      }
    }
  }

  /**
   * Synchronous tooltip builder — no async/await calls.
   * Avoids binding promises to [attr.title] which caused infinite CD loops.
   */
  buildTripTooltipSync(trip: any): any[] {
    const tz = this.timeZone;
    const scheduledStart = moment.tz(trip.scheduleTime, tz);
    const scheduledEnd = moment.tz(trip.appointmentTime || trip.scheduleTime, tz);

    // Helper to convert raw minutes to "1h 10m" or "10m"
    const formatMins = (mins: number): string => this.formatMins(mins);

    if (trip.isBreakTrip) {
      return [{ label: 'Break', value: `${scheduledStart.format(this.timeFormat)} – ${scheduledEnd.format(this.timeFormat)}` }];
    }

    const lines: any[] = [];

    // 1. Header Information
    lines.push({ label: 'Scheduled', value: `${scheduledStart.format(this.timeFormat)} → ${scheduledEnd.format(this.timeFormat)}` });

    if (trip.tripId) {
      lines.push({ label: 'ID', value: `#${trip.tripId}` });
    }

    if (trip.isConfirmedTrip) {
      lines.push({ label: 'Confirmed', value: 'Yes', isSuccess: true });
    }

    const displayStatus = this.formatJobStatus(trip.jobStatus);
    lines.push({ label: 'Status', value: displayStatus });

    const trackInfo = trip.job && trip.job.trackInfoJob;

    // 3. Historical Data
    if (trackInfo) {
      lines.push({ isDivider: true });
      if (trackInfo.jobAccepted && trackInfo.jobAccepted.time) {
        lines.push({ label: 'Onway', value: moment.tz(trackInfo.jobAccepted.time, tz).format(this.timeFormat) });
      }
      if (trackInfo.jobArrived && trackInfo.jobArrived.time) {
        lines.push({ label: 'Arrived', value: moment.tz(trackInfo.jobArrived.time, tz).format(this.timeFormat) });
      }

      const finishEventTime = (trackInfo.jobFinished && trackInfo.jobFinished.time) ||
        (trackInfo.jobCompleted && trackInfo.jobCompleted.time) ||
        (trackInfo.jobCancelled && trackInfo.jobCancelled.time);
      if (finishEventTime) {
        const titleLabel = trip.jobStatus === 'cancelled' ? 'Cancelled' : 'Completed';
        lines.push({ label: titleLabel, value: moment.tz(finishEventTime, tz).format(this.timeFormat) });
      }
    }

    const isFinished = ['finished', 'completed', 'cancelled'].includes(trip.jobStatus);

    if (!isFinished) {
      lines.push({ isDivider: true });

      // 2. Travel Buffers (Formatted to h m)
      // Note: These will naturally hide if computeDelayChain set them to 0
      if (trip._preTravelMins) {
        const milesText = trip._preTravelMiles ? ` (${trip._preTravelMiles.toFixed(2)} mi)` : '';
        lines.push({ label: 'Deadhead Time', value: `${formatMins(trip._preTravelMins)}${milesText}` });
      }
      if (trip._actualTravelMins) {
        const milesText = trip._actualTravelMiles ? ` (${trip._actualTravelMiles.toFixed(2)} mi)` : '';
        lines.push({ label: 'Loaded Time', value: `${formatMins(trip._actualTravelMins)}${milesText}` });
      }
    }

    // 4. Forecast Data
    if (!isFinished) {
      const hasArrived = trackInfo && trackInfo.jobArrived && trackInfo.jobArrived.time;
      let addedForecastDivider = false;

      // ETA to Pickup only shows if not arrived and not zero
      if (!hasArrived && trip._forecastStartETA) {
        if (!addedForecastDivider) { lines.push({ isDivider: true }); addedForecastDivider = true; }
        lines.push({ label: 'Est. ETA(P)', value: trip._forecastStartETA });
      }

      if (trip._forecastEndETA) {
        if (!addedForecastDivider) { lines.push({ isDivider: true }); addedForecastDivider = true; }
        lines.push({ label: 'Est. ETA(D)', value: trip._forecastEndETA });
      }
    }

    // 5. The Delay Section (Formatted to h m)
    const hasPickupDelay = trip._isPickupDelayed && Number(trip._delayPickupMins) > 0;
    const hasDropOffDelay = trip._isDropOffDelayed && Number(trip._dropOffDelayMins) > 0;

    if (!isFinished && (hasPickupDelay || hasDropOffDelay)) {
      lines.push({ isDivider: true });
      if (hasPickupDelay) {
        // Shows "+15 min" or "+1h 10m"
        lines.push({ label: '⚠ Late(P)', value: `+${formatMins(trip._delayPickupMins)}`, isWarning: true });
      }
      if (hasDropOffDelay) {
        lines.push({ label: '⚠ Late(D)', value: `+${formatMins(trip._dropOffDelayMins)}`, isWarning: true });
      }
    }

    return lines;
  }

  formatJobStatus(status?: string) {
    if (!status) return '';

    const normalized = status.toLowerCase();

    const statusMap: Record<string, string> = {
      pending: 'Unassigned',
      arrived: 'On Scene',
      started: 'Member Onboard',
    };

    // Return mapped value if exists
    if (statusMap[normalized]) {
      return statusMap[normalized];
    }

    // Fallback → Title Case + clean underscores
    return normalized
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  openEditModal(trip: any) {
    this.closeInlineTimeEdit(trip);
    // const fundingSource = trip.cooperate ? this.preCooperates[trip.cooperate] : null;
    // if (fundingSource && fundingSource.companyType === 'taxi') {
    //   this.editTaxiRideModalObj = trip._id
    //   return;
    // }
    this.editTripModalObj = trip._id;
  }

  onEditTrip(evt) {
    if (evt) {
      this.editTripModalObj = null;
      this.editTaxiRideModalObj = null;
      this.getRefreshTrips();
    }
  }

  openDetailsModal(trip: any) {
    this.closeInlineTimeEdit(trip);
    this.isDetailsModalOpen = true;
    if (trip.job) {
      this.viewCompletedTripDetails(trip);
    } else {
      this.openDetailModal(trip);
    }
  }

  isTripModificationNotAllowed(trip) {
    let bln = false;
    if (
      this.preCooperates &&
      this.preCooperates[trip.cooperate] &&
      this.preCooperates[trip.cooperate].isTripModificationNotAllowed
    ) {
      bln = true;
    }
    return bln;
  }

  isTaxiRide(assign: any) {
    const fundingSource = assign.cooperate ? this.preCooperates[assign.cooperate] : null;
    return !!(fundingSource && fundingSource.companyType === 'taxi');
  }

  canEditTimes(trip: any): boolean {
    return !trip.isBreakTrip && !this.isTaxiRide(trip) && !this.isTripModificationNotAllowed(trip);
  }

  isInlineEditing(trip: any, field: 'scheduleTime' | 'appointmentTime'): boolean {
    return !!this.editingTimeField && this.editingTimeField.tripId === trip._id && this.editingTimeField.field === field;
  }

  startInlineTimeEdit(trip: any, field: 'scheduleTime' | 'appointmentTime') {
    if (!this.canEditTimes(trip)) return;
    this.editingTimeField = {
      tripId: trip._id,
      field,
      meridiem: this.isAmPmFormat() ? moment(trip[field]).tz(this.timeZone).format('A') as 'AM' | 'PM' : undefined
    };
    this.cdr.markForCheck();
  }

  /** Flips AM/PM for the field currently being edited and saves immediately. */
  toggleMeridiem(trip: any, field: 'scheduleTime' | 'appointmentTime', inputEl: HTMLInputElement) {
    if (!this.isInlineEditing(trip, field)) return;
    this.editingTimeField = { ...this.editingTimeField, meridiem: this.editingTimeField.meridiem === 'AM' ? 'PM' : 'AM' };
    this.clearInlineTimeDebounce(trip, field);
    this.saveInlineTime({ target: inputEl }, trip, field);
  }

  /** Removes the inline time input (for either field) so it can't stay focused/open behind a modal opened from the same card. */
  closeInlineTimeEdit(trip: any) {
    if (this.editingTimeField && this.editingTimeField.tripId === trip._id) {
      this.editingTimeField = null;
      this.cdr.markForCheck();
    }
  }

  /** Value (HHmm, in the company timezone) to seed the plain text input with when a field opens for editing. */
  getInlineTimeInputValue(trip: any, field: 'scheduleTime' | 'appointmentTime'): string {
    const val = trip[field];
    if (!val) return '';
    return moment(val).tz(this.timeZone).format(this.isAmPmFormat() ? 'hhmm' : 'HHmm');
  }

  /** Same as verified-trip-logs' restrictToDigits — strips non-digits as the user types. */
  restrictToDigits(event: any) {
    const input = event.target;
    const cleaned = input.value.replace(/[^0-9]/g, '');
    if (input.value !== cleaned) {
      input.value = cleaned;
    }
  }

  /** Requires exactly 4 digits ("HHmm"); returns null if the text isn't a valid time. */
  private parseInlineTimeInput(value: string): { hours: number; minutes: number } | null {
    if (!value) return null;
    const digits = value.trim().replace(/\D/g, '');
    if (digits.length !== 4) return null;

    const hours = Number(digits.slice(0, 2));
    const minutes = Number(digits.slice(2, 4));
    if (hours > 23 || minutes > 59) return null;

    return { hours, minutes };
  }

  /** scheduleTime must be strictly before appointmentTime, and vice versa — returns an error message, or null if OK. */
  private getTimeSequenceError(trip: any, field: 'scheduleTime' | 'appointmentTime', newValue: string): string | null {
    const otherField = field === 'scheduleTime' ? 'appointmentTime' : 'scheduleTime';
    const otherValue = trip[otherField];
    if (!otherValue) return null;

    const newMoment = moment(newValue);
    const otherMoment = moment(otherValue);

    if (field === 'scheduleTime' && !newMoment.isBefore(otherMoment)) {
      return 'Pickup time must be before the dropoff time';
    }
    if (field === 'appointmentTime' && !newMoment.isAfter(otherMoment)) {
      return 'Dropoff time must be after the pickup time';
    }
    return null;
  }

  private inlineTimeDebounceKey(trip: any, field: 'scheduleTime' | 'appointmentTime'): string {
    return trip._id + '_' + field;
  }

  private clearInlineTimeDebounce(trip: any, field: 'scheduleTime' | 'appointmentTime') {
    const timerKey = this.inlineTimeDebounceKey(trip, field);
    if (this.inlineTimeDebounceTimers[timerKey]) {
      clearTimeout(this.inlineTimeDebounceTimers[timerKey]);
      delete this.inlineTimeDebounceTimers[timerKey];
      this.cdr.markForCheck();
    }
  }

  /** True while the update-trip API call for this trip's inline time edit is actually in flight — drives the "Saving…" indicator. */
  isSavingTime(trip: any): boolean {
    return this.savingTripId === trip._id;
  }

  /** Debounced auto-save while the user is still typing — mirrors onInlineTimestampInput in verified-trip-logs. */
  onInlineTimeInput(event: any, trip: any, field: 'scheduleTime' | 'appointmentTime') {
    this.clearInlineTimeDebounce(trip, field);
    const timerKey = this.inlineTimeDebounceKey(trip, field);
    this.inlineTimeDebounceTimers[timerKey] = setTimeout(() => {
      delete this.inlineTimeDebounceTimers[timerKey];
      this.saveInlineTime(event, trip, field);
    }, 2000);
  }

  /** Fired when the input loses focus — saves immediately. */
  onInlineTimeChange(event: any, trip: any, field: 'scheduleTime' | 'appointmentTime') {
    this.clearInlineTimeDebounce(trip, field);
    this.saveInlineTime(event, trip, field);
  }

  /** Rejects the in-progress edit: shows why, snaps the input back to the last known-good value, and closes it. */
  private rejectInlineTimeEdit(event: any, trip: any, field: 'scheduleTime' | 'appointmentTime', message: string) {
    this.toastr.error(message, 'Error');
    event.target.value = this.getInlineTimeInputValue(trip, field);
    this.finishInlineTimeEdit(trip, field);
  }

  private saveInlineTime(event: any, trip: any, field: 'scheduleTime' | 'appointmentTime') {
    debugger;
    const rawValue = (event.target.value || '').trim();
    if (!rawValue) {
      this.rejectInlineTimeEdit(event, trip, field, 'Time cannot be empty');
      return;
    }

    // In 12-hour mode the input holds "hhmm" and the AM/PM comes from the toggle (or, if the field is no
    // longer open, from its current value) — convert to "HHmm" first.
    const meridiem = this.isInlineEditing(trip, field) ? this.editingTimeField.meridiem : moment(trip[field]).tz(this.timeZone).format('A');
    const parsed = this.parseInlineTimeInput(this.isAmPmFormat() ? moment(rawValue + meridiem, 'hhmmA', true).format('HHmm') : rawValue);
    if (!parsed) {
      this.rejectInlineTimeEdit(event, trip, field, 'Invalid time format. Use ' + (this.isAmPmFormat() ? 'hhmm (e.g. 0230)' : 'HHmm (e.g. 1430)'));
      return;
    }

    const currentTime = trip[field] ? moment(trip[field]).tz(this.timeZone) : moment().tz(this.timeZone);

    // Skip if value hasn't changed
    if (currentTime.hour() === parsed.hours && currentTime.minute() === parsed.minutes) {
      this.finishInlineTimeEdit(trip, field);
      return;
    }

    const previousValues: { scheduleTime?: string | null; appointmentTime?: string | null } = { [field]: trip[field] || null };
    const newMoment = currentTime.clone().set({ hour: parsed.hours, minute: parsed.minutes, second: 0, millisecond: 0 });
    const newValue = newMoment.toISOString();

    // Skipped for scheduleTime: it always carries the dropoff time along with it below, so the
    // result is valid by construction — checking against the not-yet-updated old dropoff time here
    // would wrongly block a schedule change the cascade is about to fix anyway.
    if (field === 'appointmentTime') {
      const sequenceError = this.getTimeSequenceError(trip, field, newValue);
      if (sequenceError) {
        this.rejectInlineTimeEdit(event, trip, field, sequenceError);
        return;
      }
    }

    trip[field] = newValue;
    event.target.value = newMoment.format(this.isAmPmFormat() ? 'hhmm' : 'HHmm');

    // Moving the pickup time carries the dropoff time along with it (pickup + 1 hour), so the two
    // never drift apart and the user isn't left having to set the dropoff time by hand every time.
    if (field === 'scheduleTime') {
      previousValues.appointmentTime = trip.appointmentTime || null;
      trip.appointmentTime = newMoment.clone().add(1, 'hour').toISOString();
    }

    const tripIndex = this.allTrips.findIndex((t: any) => t._id === trip._id);
    if (tripIndex !== -1) {
      this.allTrips[tripIndex] = { ...this.allTrips[tripIndex], scheduleTime: trip.scheduleTime, appointmentTime: trip.appointmentTime };
    }
    this.cdr.markForCheck();

    this.updateTrip(trip, field, previousValues);
  }

  /** Same update-trip API the trip edit form (new-trip.component.ts onCreateTrip) uses to save an existing trip. Always
   * collapses the field back to plain text once the API responds — success or failure — so it never stays stuck in edit mode.
   * On failure, reverts the optimistic local update(s) so the UI doesn't show values that were never actually persisted. */
  private updateTrip(
    trip: any,
    field: 'scheduleTime' | 'appointmentTime',
    previousValues: { scheduleTime?: string | null; appointmentTime?: string | null }
  ) {
    const payload = { ...trip };

    this.savingTripId = trip._id;
    this.cdr.markForCheck();

    this.assignTripService
      .createNewTripV2(payload, trip._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        data => {
          this.clearSavingIndicator(trip._id);
          if (data) {
            this.showFieldSavedFlash(trip._id, field);
            if (field === 'scheduleTime') {
              // The dropoff time moved along with the pickup time (pickup + 1 hour) — flash it too
              // so it's clear both values changed together, not just the one that was directly edited.
              this.showFieldSavedFlash(trip._id, 'appointmentTime');
            }
            this.toastr.success('Time updated successfully', 'Success');
          }
          this.finishInlineTimeEdit(trip, field);
          if (data && field === 'scheduleTime') {
            // Both times are already saved (the dropoff time was carried along above) — reopen the
            // dropoff field in edit mode so the user can review/adjust the auto-computed value.
            this.startInlineTimeEdit(trip, 'appointmentTime');
          }
          // Force the view to reflect the above synchronously — markForCheck alone can leave the
          // card showing a stale value until some unrelated event (e.g. hover) triggers the next tick.
          this.cdr.detectChanges();

          if (data && field === 'scheduleTime') {
            // The `autofocus` attribute on a freshly-inserted input isn't reliably honored when the
            // insertion happens inside an async callback rather than a direct user gesture — focus it
            // explicitly once the browser has actually painted the new element.
            setTimeout(() => {
              const el = document.getElementById('inline-apt-time-' + trip._id) as HTMLInputElement | null;
              if (el) {
                el.focus();
                el.select();
              }
            });
          }
        },
        err => {
          this.clearSavingIndicator(trip._id);
          this.revertInlineTimeField(trip, previousValues);
          this.toastr.error('Failed to update time', 'Error');
          this.finishInlineTimeEdit(trip, field);
          this.cdr.detectChanges();
        }
      );
  }

  /** Restores field(s) to their pre-edit values after a failed save, both on the live trip object and in allTrips. */
  private revertInlineTimeField(trip: any, previousValues: { scheduleTime?: string | null; appointmentTime?: string | null }) {
    Object.assign(trip, previousValues);

    const tripIndex = this.allTrips.findIndex((t: any) => t._id === trip._id);
    if (tripIndex !== -1) {
      this.allTrips[tripIndex] = { ...this.allTrips[tripIndex], ...previousValues };
    }
  }

  private clearSavingIndicator(tripId: string) {
    if (this.savingTripId === tripId) {
      this.savingTripId = null;
      this.cdr.markForCheck();
    }
  }

  /** Briefly flashes the edited value green in place instead of a toast — draws the eye to exactly what changed. */
  private showFieldSavedFlash(tripId: string, field: 'scheduleTime' | 'appointmentTime') {
    const key = tripId + '_' + field;
    if (this.justSavedFieldTimers[key]) {
      clearTimeout(this.justSavedFieldTimers[key]);
    }

    this.justSavedFields.add(key);
    this.cdr.markForCheck();

    this.justSavedFieldTimers[key] = setTimeout(() => {
      delete this.justSavedFieldTimers[key];
      this.justSavedFields.delete(key);
      this.cdr.markForCheck();
    }, 700);
  }

  isJustSaved(trip: any, field: 'scheduleTime' | 'appointmentTime'): boolean {
    return this.justSavedFields.has(trip._id + '_' + field);
  }

  /** Collapses the inline input back to plain text. */
  private finishInlineTimeEdit(trip: any, field: 'scheduleTime' | 'appointmentTime') {
    if (this.editingTimeField && this.editingTimeField.tripId === trip._id && this.editingTimeField.field === field) {
      this.editingTimeField = null;
      this.cdr.markForCheck();
    }
  }

  // ==================== Multi-select drag-drop (unassigned sidebar → driver) ====================

  toggleTripSelection(trip: any): void {
    if (this.selectedUnassignedTripIds.has(trip._id)) {
      this.selectedUnassignedTripIds.delete(trip._id);
    } else {
      this.selectedUnassignedTripIds.add(trip._id);
    }
    this.cdr.markForCheck();
  }

  isTripSelected(trip: any): boolean {
    return this.selectedUnassignedTripIds.has(trip._id);
  }

  /**
   * True if dragging this card would carry the whole checked selection along with it.
   * Driven by checkbox state (settled well before any drag gesture starts), not by
   * drag-start state — that keeps the *cdkDragPreview presence check free of any
   * dependency on change-detection timing during CDK's synchronous drag-start handling.
   */
  isMultiDragCandidate(trip: any): boolean {
    return this.selectedUnassignedTripIds.has(trip._id) && this.selectedUnassignedTripIds.size > 1;
  }

  isTripBeingDragged(trip: any): boolean {
    return this.activeDragTripIds.includes(trip._id);
  }

  clearTripSelection(): void {
    this.selectedUnassignedTripIds.clear();
    this.cdr.markForCheck();
  }

  /** True when this drop carries a checked multi-select of unassigned trips onto a driver column. */
  private isMultiTripDrag(event: CdkDragDrop<any>): boolean {
    const trip = event.item.data;
    const driverId = event.container.data;
    const previousDriverId = event.previousContainer.data;

    return previousDriverId === 'no_driver' &&
      driverId !== previousDriverId &&
      driverId !== 'no_driver' &&
      this.activeDragTripIds.length > 1 &&
      this.activeDragTripIds.includes(trip._id);
  }

  /** Handles a multi-select drag-drop: assigns every checked unassigned trip to the target driver. */
  private async onMultiTripDropped(event: CdkDragDrop<any>): Promise<void> {
    const driverId = event.container.data;
    const tripIds = [...this.activeDragTripIds];
    this.activeDragTripIds = [];
    await this.assignMultipleTripsToDriver(tripIds, driverId);
  }

  /** Assigns several checked unassigned trips to one driver in a single drag-drop gesture. */
  async assignMultipleTripsToDriver(tripIds: string[], driverId: string): Promise<void> {
    const targetDriver = (this.preDriverList as any)[driverId];
    if (!targetDriver) return;

    const trips = tripIds
      .map(id => this.allTrips.find(t => t._id === id))
      .filter(t => !!t);

    if (!trips.length) return;

    const result = await sweetAlert(
      'Alert',
      `Are you sure you want to assign ${trips.length} trips to ${targetDriver.displayName}?`,
      'warning', 'Yes', 'No'
    );
    if (!result.value) return;

    // One undo step for the whole batch, matching single-trip drag-drop's "one action, one undo step".
    this.undoStack.push({
      type: 'multiAssign',
      trip: null,
      prevDriverId: null,
      prevStatus: 'unassigned',
      prevJobStatus: 'pending',
      driverName: 'Unassigned',
      tripIds: trips.map(t => t._id)
    });

    trips.forEach(trip => {
      trip.driver = { ...targetDriver };
      trip.status = 'offered';
      trip.jobStatus = 'offered';

      const tripIndex = this.allTrips.findIndex(t => t._id === trip._id);
      if (tripIndex !== -1) {
        this.allTrips[tripIndex] = trip;
      }
    });

    this.persistMultipleAssignment(trips, targetDriver);

    this.clearTripSelection();
    this.toastr.success(`${trips.length} trips assigned to ${targetDriver.displayName}`, 'Success');
    await this.prepareDataFilters();
    this.cdr.markForCheck();
  }

  /**
   * Persists a multi-trip assignment via the same bulk multi-assign API used by
   * TripAssignModalComponent's "Multiple Assign" flow (assignTripService.assignMultipleTrip).
   */
  private persistMultipleAssignment(trips: any[], targetDriver: any): void {
    const payload = {
      selectedTrips: trips.map(t => t._id),
      status: 'offered',
      priority: 0,
      assignThrough: 'panel',
      driver: targetDriver
    };

    this.assignTripService
      .assignMultipleTrip(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  /** Reverts a whole multi-select assignment batch back to unassigned in one step. */
  private undoMultiAssignment(tripIds: string[]): void {
    const trips: any[] = this.allTrips as any[];

    tripIds.forEach(id => {
      const tripIndex = trips.findIndex((t: any) => t._id === id);
      if (tripIndex === -1) return;
      const liveTripObj = { ...trips[tripIndex] };
      liveTripObj.driver = null;
      liveTripObj.status = 'unassigned';
      liveTripObj.jobStatus = 'pending';
      trips[tripIndex] = liveTripObj;
    });

    this.prepareDataFilters();
    this.cdr.markForCheck();

    const payload = {
      selectedTrips: tripIds,
      status: 'unassigned',
      priority: 0,
      assignThrough: 'panel'
    };
    this.assignTripService
      .assignMultipleTrip(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }
}



